<template>
  <Breadcrumbs title="" />
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header" v-if="this.event_register.title">
            <div class="d-flex justify-content-center">
              <figure class="col-xl-12 col-sm-12">
                <img :src="this.event_register.coverurl" alt="Image description" class="event-cover" />
              </figure>
            </div>
            <h3> {{ this.event_register.title }}</h3>
            <p>
              <b><i class="fa fa-calendar-check-o" aria-hidden="true"></i> {{this.currentLanguage ==='en'?'Event date':'วันที่จัดกิจกรรม'}}: {{ this.event_register.event_date_text }}
              </b>
              <br />
              <b>&nbsp;<i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp; {{ this.event_register.location }} </b>
              <br />
            </p>
          </div>

          <div class="card-header event-register-skeleton" v-if="!this.event_register.title">
            <div class="skeleton-block skeleton-cover mb-3"></div>
            <div class="skeleton-block skeleton-title mb-2"></div>
            <div class="skeleton-block skeleton-line mb-2"></div>
            <div class="skeleton-block skeleton-line skeleton-line-short"></div>
          </div>
        </div>
      </div>
      <div v-if="this.event_register.is_open_register === 'Y'" >

        <div v-if="this.can_create_order_participate_full==='LOADING'" class="col-sm-12">
          <div class="card">
            <div class="card-body event-register-skeleton">
              <div class="skeleton-block skeleton-title mb-3"></div>
              <div class="skeleton-block skeleton-line mb-2"></div>
              <div class="skeleton-block skeleton-line mb-2"></div>
              <div class="skeleton-block skeleton-line skeleton-line-short"></div>
            </div>
          </div>
        </div>
        <div v-if="this.can_create_order_participate_full==='N'">
          <div class="d-flex justify-content-center">
             <h5> </h5>
             {{this.currentLanguage ==='en'?'The registration is now full. We sincerely thank you for your interest and support in our event.':'ขณะนี้มีผู้สมัครครบตามจำนวนที่กำหนดแล้ว ขอขอบพระคุณเป็นอย่างสูงสำหรับความสนใจและการตอบรับกิจกรรมของเรา'}}
            </div>
        </div>
        <div v-if="this.event_register.id_production_mode !== 'Y'" class="alert alert-secondary text-center blinking-text" role="alert" style="font-size: 1.2em; font-weight: bold; margin-bottom: 1.5em; background-color: #6c757d; color: white; border-color: #5a6268;">
          <span v-if="this.currentLanguage ==='en'">🚧 You are currently using test mode. All data entered will be cancelled when going live 🚧</span>
          <span v-else>🚧 ท่านใช้งานอยู่ในโหมดทดสอบ ข้อมูลที่กรอกมาทั้งหมดจะถูกยกเลิกเมื่อเปิดใช้งานจริง 🚧</span>
        </div>
        <div v-if="this.can_create_order_participate_full==='Y'">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-header">
                <h3>{{this.currentLanguage ==='en'?'Step':'ขั้นตอนการสมัคร'}}</h3>
                <div class="stepper-wrapper">
                  <div class="stepper-item completed">
                    <div class="step-counter">1</div>
                    <div class="step-name">{{this.currentLanguage ==='en'?'Infomation':'ข้อมูลผู้สมัคร'}}</div>
                  </div>
                  <div class="stepper-item completed">
                    <div class="step-counter">2</div>
                    <div class="step-name">{{this.currentLanguage ==='en'?'Address':'ข้อมูลที่อยู่'}}</div>
                  </div>
                  <div class="stepper-item ">
                    <div class="step-counter">3</div>
                    <div class="step-name">{{this.currentLanguage ==='en'?'Payment':'ชำระเงิน'}}</div>
                  </div>
                  <div class="stepper-item">
                    <div class="step-counter">4</div>
                    <div class="step-name">{{this.currentLanguage ==='en'?'Completed':'เสร็จสมบูรณ์'}}</div>
                  </div>
                </div>

              </div>

              <div class="card-body">
                <h3>2. {{this.currentLanguage ==='en'?'Registration form':'กรอกข้อมูลผู้เข้าแข่งขัน'}} <span style="color: red;">*</span></h3>
                
                <form @submit.prevent="addRunner" @beforeinput.capture="blockForbiddenCharacters" @paste.capture="blockForbiddenPaste" class="needs-validation">
                  
                  <span v-if="2==5" >
                  <p>&nbsp;</p>
                  <h4>Participant info</h4>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" v-model="register_type" checked required type="radio"
                      name="inlineRadioOptions" id="inlineRadio1" value="MYSELF">
                    <label class="form-check-label" for="inlineRadio1">
                      <h5>{{this.currentLanguage ==='en'?'Myself':'สมัครให้ตัวเอง'}}</h5>
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" v-model="register_type" type="radio" required name="inlineRadioOptions"
                      id="inlineRadio2" value="FRIEND">
                    <label class="form-check-label" for="inlineRadio2">
                      <h5>{{this.currentLanguage ==='en'?'For Friends':'สมัครให้เพื่อน'}}</h5>
                    </label>
                  </div>
                  </span>
                  <p>&nbsp;</p>
                  <div class="col-sm-12">
                    <h4>{{this.currentLanguage ==='en'?'Personal Information':'ข้อมูลส่วนตัวผู้สมัคร'}}</h4>
                    <div class="row">
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="3" maxlength="40"  required v-model="fname" @input="clearValidationErrors" class="form-control" id="fname">
                          <label for="fname">{{this.currentLanguage ==='en'?'Name (No Prefix)':'ชื่อ (ไม่ต้องมีคำนำหน้า) '}} <span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="3" maxlength="40" required v-model="lname" @input="clearValidationErrors" class="form-control" id="lname">
                          <label for="lname">{{this.currentLanguage ==='en'?'Last Name':'นามสกุล'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>
                      <div v-if="event_register.is_store_name_en === 'Y'" class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" required maxlength="40" pattern="(?=.*[A-Za-z])[A-Za-z0-9 ]+" v-model="fname_en" @input="fname_en = fname_en.replace(/[^A-Za-z0-9 ]/g, ''); $event.target.value = fname_en; clearValidationErrors()" class="form-control" id="fname_en">
                          <label for="fname_en">{{ currentLanguage === 'en' ? 'First Name in English' : 'ชื่อ (ภาษาอังกฤษ)' }} *</label>
                        </div>
                      </div>
                      <div v-if="event_register.is_store_name_en === 'Y'" class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" required maxlength="40" pattern="(?=.*[A-Za-z])[A-Za-z0-9 ]+" v-model="lname_en" @input="lname_en = lname_en.replace(/[^A-Za-z0-9 ]/g, ''); $event.target.value = lname_en; clearValidationErrors()" class="form-control" id="lname_en">
                          <label for="lname_en">{{ currentLanguage === 'en' ? 'Last Name in English' : 'นามสกุล (ภาษาอังกฤษ)' }} *</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="sex" @change="clearValidationErrors" id="sex" aria-label="Floating label select example">
                            <option value="MALE">{{this.currentLanguage ==='en'?'MALE':'ชาย'}}</option>
                            <option value="FEMALE">{{this.currentLanguage ==='en'?'FEMALE':'หญิง'}}</option>
                          </select>
                          <label for="sex">{{this.currentLanguage ==='en'?'Gender':'เพศ'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>

                      <div class="col-sm-4 col-lg-2 col-xl-1">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="dobd" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="01" selected>1</option>
                            <option value="02">2</option>
                            <option value="03">3</option>
                            <option value="04">4</option>
                            <option value="05">5</option>
                            <option value="06">6</option>
                            <option value="07">7</option>
                            <option value="08">8</option>
                            <option value="09">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                            <option value="24">24</option>
                            <option value="25">25</option>
                            <option value="26">26</option>
                            <option value="27">27</option>
                            <option value="28">28</option>
                            <option value="29">29</option>
                            <option value="30">30</option>
                            <option value="31">31</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Date of Birth':'วันเกิด'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-2">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="dobm" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="01" selected>{{this.currentLanguage ==='en'?'January':'มกราคม'}}</option>
                            <option value="02">{{this.currentLanguage ==='en'?'February':'กุมภาพันธ์'}}</option>
                            <option value="03">{{this.currentLanguage ==='en'?'March':'มีนาคม'}}</option>
                            <option value="04">{{this.currentLanguage ==='en'?'April':'เมษายน'}}</option>
                            <option value="05">{{this.currentLanguage ==='en'?'May':'พฤษภาคม'}}</option>
                            <option value="06">{{this.currentLanguage ==='en'?'June':'มิถุนายน'}}</option>
                            <option value="07">{{this.currentLanguage ==='en'?'July':'กรกฎาคม'}}</option>
                            <option value="08">{{this.currentLanguage ==='en'?'August':'สิงหาคม'}}</option>
                            <option value="09">{{this.currentLanguage ==='en'?'September':'กันยายน'}}</option>
                            <option value="10">{{this.currentLanguage ==='en'?'October':'ตุลาคม'}}</option>
                            <option value="11">{{this.currentLanguage ==='en'?'November':'พฤศจิกายน'}}</option>
                            <option value="12">{{this.currentLanguage ==='en'?'December':'ธันวาคม'}}</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Month':'เดือนเกิด'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-1">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="doby" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="1934">พ.ศ. 2477</option>
                            <option value="1935">พ.ศ. 2478</option>
                            <option value="1936">พ.ศ. 2479</option>
                            <option value="1937">พ.ศ. 2480</option>
                            <option value="1938">พ.ศ. 2481</option>
                            <option value="1939">พ.ศ. 2482</option>
                            <option value="1940">พ.ศ. 2483</option>
                            <option value="1941">พ.ศ. 2484</option>
                            <option value="1942">พ.ศ. 2485</option>
                            <option value="1943">พ.ศ. 2486</option>
                            <option value="1944">พ.ศ. 2487</option>
                            <option value="1945">พ.ศ. 2488</option>
                            <option value="1946">พ.ศ. 2489</option>
                            <option value="1947">พ.ศ. 2490</option>
                            <option value="1948">พ.ศ. 2491</option>
                            <option value="1949">พ.ศ. 2492</option>
                            <option value="1950">พ.ศ. 2493</option>
                            <option value="1951">พ.ศ. 2494</option>
                            <option value="1952">พ.ศ. 2495</option>
                            <option value="1953">พ.ศ. 2496</option>
                            <option value="1954">พ.ศ. 2497</option>
                            <option value="1955">พ.ศ. 2498</option>
                            <option value="1956">พ.ศ. 2499</option>
                            <option value="1957">พ.ศ. 2500</option>
                            <option value="1958">พ.ศ. 2501</option>
                            <option value="1959">พ.ศ. 2502</option>
                            <option value="1960">พ.ศ. 2503</option>
                            <option value="1961">พ.ศ. 2504</option>
                            <option value="1962">พ.ศ. 2505</option>
                            <option value="1963">พ.ศ. 2506</option>
                            <option value="1964">พ.ศ. 2507</option>
                            <option value="1965">พ.ศ. 2508</option>
                            <option value="1966">พ.ศ. 2509</option>
                            <option value="1967">พ.ศ. 2510</option>
                            <option value="1968">พ.ศ. 2511</option>
                            <option value="1969">พ.ศ. 2512</option>
                            <option value="1970">พ.ศ. 2513</option>
                            <option value="1971">พ.ศ. 2514</option>
                            <option value="1972">พ.ศ. 2515</option>
                            <option value="1973">พ.ศ. 2516</option>
                            <option value="1974">พ.ศ. 2517</option>
                            <option value="1975">พ.ศ. 2518</option>
                            <option value="1976">พ.ศ. 2519</option>
                            <option value="1977">พ.ศ. 2520</option>
                            <option value="1978">พ.ศ. 2521</option>
                            <option value="1979">พ.ศ. 2522</option>
                            <option value="1980">พ.ศ. 2523</option>
                            <option value="1981">พ.ศ. 2524</option>
                            <option value="1982">พ.ศ. 2525</option>
                            <option value="1983">พ.ศ. 2526</option>
                            <option value="1984">พ.ศ. 2527</option>
                            <option value="1985">พ.ศ. 2528</option>
                            <option value="1986">พ.ศ. 2529</option>
                            <option value="1987">พ.ศ. 2530</option>
                            <option value="1988">พ.ศ. 2531</option>
                            <option value="1989">พ.ศ. 2532</option>
                            <option value="1990">พ.ศ. 2533</option>
                            <option value="1991">พ.ศ. 2534</option>
                            <option value="1992">พ.ศ. 2535</option>
                            <option value="1993">พ.ศ. 2536</option>
                            <option value="1994">พ.ศ. 2537</option>
                            <option value="1995">พ.ศ. 2538</option>
                            <option value="1996">พ.ศ. 2539</option>
                            <option value="1997">พ.ศ. 2540</option>
                            <option value="1998">พ.ศ. 2541</option>
                            <option value="1999">พ.ศ. 2542</option>
                            <option value="2000">พ.ศ. 2543</option>
                            <option value="2001">พ.ศ. 2544</option>
                            <option value="2002">พ.ศ. 2545</option>
                            <option value="2003">พ.ศ. 2546</option>
                            <option value="2004">พ.ศ. 2547</option>
                            <option value="2005">พ.ศ. 2548</option>
                            <option value="2006">พ.ศ. 2549</option>
                            <option value="2007">พ.ศ. 2550</option>
                            <option value="2008">พ.ศ. 2551</option>
                            <option value="2009">พ.ศ. 2552</option>
                            <option value="2010">พ.ศ. 2553</option>
                            <option value="2011">พ.ศ. 2554</option>
                            <option value="2012">พ.ศ. 2555</option>
                            <option value="2013">พ.ศ. 2556</option>
                            <option value="2014">พ.ศ. 2557</option>
                            <option value="2015">พ.ศ. 2558</option>
                            <option value="2016">พ.ศ. 2559</option>
                            <option value="2017">พ.ศ. 2560</option>
                            <option value="2018">พ.ศ. 2561</option>
                            <option value="2019">พ.ศ. 2562</option>
                            <option value="2020">พ.ศ. 2563</option>
                            <option value="2021">พ.ศ. 2564</option>
                            <option value="2022">พ.ศ. 2565</option>
                            <option value="2023">พ.ศ. 2566</option>
                            <option value="2024">พ.ศ. 2567</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Year(BE)':'ปีเกิด'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>


                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="nationality" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="THAI" selected>{{this.currentLanguage ==='en'?'Thai':'ไทย'}}</option>
                            <option value="OTHER" >{{this.currentLanguage ==='en'?'Other':'อื่น ๆ'}}</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Nationality':'สัญชาติ'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>

                      <div :class="this.event_register.is_require_id_card==='Y'?'col-sm-12 col-lg-6 col-xl-4':'col-sm-8 col-lg-4 col-xl-2'">
                        <div class="form-floating mb-3">
                          <input type="text" required :disabled="this.runner_action==='EDIT' ? '' : disabled || this.hide_info" class="form-control" minlength="5" maxlength="20"  @input="validateIdCardInput" v-model="id_card" 
                            id="floatingInput">
                          <label for="floatingInput">{{this.currentLanguage ==='en'?'ID card/Passport':'เลขบัตรประชาชน/พาสปอร์ต'}}{{ this.event_register.validate_idcard }}<span v-if="this.event_register.is_require_id_card==='Y'" style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>
                     
                      <div class="col-sm-4 col-lg-2 col-xl-2" v-if="this.event_register.is_require_id_card==='N'">
                        <div class="form-floating mb-3" >
                          <div class="form-check form-check-inline">
                            <input class="form-check-input" :disabled="this.runner_action==='EDIT' ? '' : disabled" type="checkbox" v-model="hide_info" @change="handleHideInfoChange" id="hide_info">
                            <label class="form-check-label" for="hide_info" style="font-size: xx-small;">
                              {{this.currentLanguage ==='en'?'Prefer not to provide information':'ไม่ประสงค์ให้ข้อมูล '}}
                            </label>
                          </div>
                          
                        </div>
                      </div>


                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="email" maxlength="40" :required="this.event_register.validate_email==='Y'? '':required" class="form-control" v-model="email" id="floatingInput">
                          <label v-if="this.event_register.validate_email==='Y' && this.event_register.event_key === 'scg113'"  for="floatingInput">{{this.currentLanguage ==='en'?'Email xxx@SCG.com':'อีเมลล์ xxx@SCG.com'}} <span style="color: red;font-size: large;">*</span></label>
                          <label v-if="this.event_register.validate_email==='N' && this.event_register.event_key === 'scg113'" for="floatingInput">{{this.currentLanguage ==='en'?'Email (if any)':'อีเมลล์ (ถ้ามี)'}} </label>

                          <label v-if="this.event_register.validate_email==='Y' && this.event_register.event_key !== 'scg113'"  for="floatingInput">{{this.currentLanguage ==='en'?'Email':'อีเมลล์'}} <span style="color: red;font-size: large;">*</span></label>
                          <label v-if="this.event_register.validate_email==='N' && this.event_register.event_key !== 'scg113'" for="floatingInput">{{this.currentLanguage ==='en'?'Email (if any)':'อีเมลล์ (ถ้ามี)'}} </label>

                          
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" required autocomplete="off" inputmode="numeric" class="form-control" minlength="10" @input="validateMobileNoInput" maxlength="10"  v-model="mobile_no" id="floatingInput">
                          <label for="floatingInput">{{this.currentLanguage ==='en'?'Mobile number':'หมายเลขโทรศัพท์'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" class="form-control" v-model="health_problem" :required="this.event_register.is_require_health_problem==='Y'? '':required" id="floatingInput">
                          <label for="floatingInput">
                            {{ this.currentLanguage === 'en'
                              ? ('health problems' + (this.event_register.is_require_health_problem === 'N' ? ' (if any)' : ''))
                              : ('ปัญหาสุขภาพ/แพ้อาหาร/แพ้ยา' + (this.event_register.is_require_health_problem === 'N' ? '(ถ้ามี)' : '')) }}
                            <span v-if="this.event_register.is_require_health_problem==='Y'" style="color: red;font-size: large;">*</span>
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" :required="this.event_register.is_require_blood_group==='Y'? '':required" v-model="blood_group" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="AB">AB</option>
                            <option value="O">O</option>
                            <option value="OTHER">Other</option>
                          </select>
                          <label for="floatingSelect">
                            {{ this.currentLanguage === 'en'
                              ? ('Blood group' + (this.event_register.is_require_blood_group === 'N' ? ' (if any)' : ''))
                              : ('หมู่เลือด' + (this.event_register.is_require_blood_group === 'N' ? '(ถ้ามี)' : '')) }}
                              <span v-if="this.event_register.is_require_blood_group === 'Y'" style="color: red;font-size: large;">*</span>
                          </label>
                        </div>
                      </div>

                      
                      <div class="col-sm-12 col-lg-6 col-xl-4" >
                        <div class="form-floating mb-3">
                          <input type="text" minlength="3" maxlength="40" :required="this.event_register.is_require_emergency_name==='Y'? '':required" class="form-control" v-model="emergency_name" id="floatingInput">
                            <label for="floatingInput">
                            {{ this.currentLanguage === 'en'
                              ? ('Emergency contact name' + (this.event_register.is_require_emergency_name === 'N' ? ' (if any)' : ''))
                              : ('ชื่อผู้ติดต่อกรณีฉุกเฉิน' + (this.event_register.is_require_emergency_name === 'N' ? '(ถ้ามี)' : '')) }}
                              <span v-if="this.event_register.is_require_emergency_name === 'Y'" style="color: red;font-size: large;">*</span>
                            </label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4" >
                        <div class="form-floating mb-3">
                          <input type="text" minlength="3" maxlength="40"  :required="this.event_register.is_require_emergency_relation==='Y'? '':required" class="form-control" v-model="emergency_relation" id="floatingInput">
                            <label for="floatingInput">
                            {{ this.currentLanguage === 'en'
                              ? ('Relationship' + (this.event_register.is_require_emergency_relation === 'N' ? ' (if any)' : ''))
                              : ('ความสัมพันธ์' + (this.event_register.is_require_emergency_relation === 'N' ? '(ถ้ามี)' : '')) }}
                              <span v-if="this.event_register.is_require_emergency_relation === 'Y'" style="color: red;font-size: large;">*</span>
                            </label>
                        </div>
                      </div>
                      <div class="col-sm-12 required col-lg-6 col-xl-4" >
                        <div class="form-floating mb-3">
                          <input type="text" minlength="10" maxlength="15" autocomplete="off" inputmode="numeric"  :required="this.event_register.is_require_emergency_mobile_no==='Y'? '':required" class="form-control" v-model="emergency_mobile_no" @input="validateEmergencyMobileNoInput" id="floatingInput">
                            <label for="floatingInput"> 
                            {{ this.currentLanguage === 'en'
                              ? ('Emergency contact phone number' + (this.event_register.is_require_emergency_mobile_no === 'N' ? ' (if any)' : ''))
                              : ('หมายเลขโทรศัพท์ผู้ติดต่อกรณีฉุกเฉิน' + (this.event_register.is_require_emergency_mobile_no === 'N' ? '(ถ้ามี)' : '')) }}
                              <span v-if="this.event_register.is_require_emergency_mobile_no === 'Y'" style="color: red;font-size: large;">*</span>
                            </label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelect" @change="handleRunTypeChange" v-model="run_type"
                            aria-label="Floating label select example">
                            <option  v-for="(event_type, index) in this.event_register.run_type" :key="index"
                              :value="event_type.id"
                              :disabled="!isRunTypeAvailable(event_type)"
                              :class="{ 'run-type-option-full': !isRunTypeAvailable(event_type) }">> {{ getRunTypeOptionLabel(event_type) }}</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Type':'ประเภทการเเข่งขัน'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4" v-if="this.event_register.is_run_model==='Y'">
                        <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelect" v-model="run_model" :disabled="this.run_type === 0 ? '' : disabled"
                            aria-label="Floating label select example">
                            <option v-for="(item, index) in this.event_register.run_model" :key="index"
                              :value="item.id">> {{ item.name }}</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Group':'การเเข่งขัน'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelect" v-model="t_shirt"
                            aria-label="Floating label select example">
                            <option v-for="(t_shirt_type, index) in this.event_register.t_shirt.filter(shirt => shirt.run_type_id === 0 || shirt.run_type_id === this.run_type)" :key="index"
                              :value="t_shirt_type.id">> {{ t_shirt_type.name }}</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Shirt size':'ขนาดเสื้อ'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>

                      <div class="col-sm-12 col-lg-6 col-xl-4" v-if="isMoreTShirt()">
                        <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelectTShirtMore" v-model="t_shirt_more"
                            aria-label="Floating label select example">
                            <option v-for="(t_shirt_more_type, index) in this.t_shirt_more_list" :key="index"
                              :value="t_shirt_more_type.id">> {{ t_shirt_more_type.name }}</option>
                          </select>
                          <label for="floatingSelectTShirtMore">{{this.currentLanguage ==='en'?'Second shirt size':'ขนาดเสื้อตัวที่สอง'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>

                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="current_province" @change="clearValidationErrors" id="current_province" aria-label="Floating label select example">
                            <option value="กรุงเทพมหานคร">กรุงเทพมหานคร (Bangkok)</option>
                            <option value="กระบี่">กระบี่ (Krabi)</option>
														<option value="กาญจนบุรี">กาญจนบุรี (Kanchanaburi)</option>
														<option value="กาฬสินธุ์">กาฬสินธุ์ (Kalasin)</option>
														<option value="กำแพงเพชร">กำแพงเพชร (Kamphaeng Phet)</option>
														<option value="ขอนแก่น">ขอนแก่น (Khon Kaen)</option>
														<option value="จันทบุรี">จันทบุรี (Chanthaburi)</option>
														<option value="ฉะเชิงเทรา">ฉะเชิงเทรา (Chachoengsao)</option>
														<option value="ชลบุรี">ชลบุรี (Chonburi)</option>
														<option value="ชัยนาท">ชัยนาท (Chai Nat)</option>
														<option value="ชัยภูมิ">ชัยภูมิ (Chaiyaphum)</option>
														<option value="ชุมพร">ชุมพร (Chumphon)</option>
														<option value="ตรัง">ตรัง (Trang)</option>
														<option value="ตราด">ตราด (Trat)</option>
														<option value="ตาก">ตาก (Tak)</option>
														<option value="นครนายก">นครนายก (Nakhon Nayok)</option>
														<option value="นครปฐม">นครปฐม (Nakhon Pathom)</option>
														<option value="นครพนม">นครพนม (Nakhon Phanom)</option>
														<option value="นครราชสีมา">นครราชสีมา (Nakhon Ratchasima)</option>
														<option value="นครศรีธรรมราช">นครศรีธรรมราช (Nakhon Si Thammarat)</option>
														<option value="นครสวรรค์">นครสวรรค์ (Nakhon Sawan)</option>
														<option value="นนทบุรี">นนทบุรี (Nonthaburi)</option>
														<option value="นราธิวาส">นราธิวาส (Narathiwat)</option>
														<option value="น่าน">น่าน (Nan)</option>
														<option value="บึงกาฬ">บึงกาฬ (Bueng Kan)</option>
														<option value="บุรีรัมย์">บุรีรัมย์ (Buriram)</option>
														<option value="ปทุมธานี">ปทุมธานี (Pathum Thani)</option>
														<option value="ประจวบคีรีขันธ์">ประจวบคีรีขันธ์ (Prachuap Khiri Khan)</option>
														<option value="ปราจีนบุรี">ปราจีนบุรี (Prachin Buri)</option>
														<option value="ปัตตานี">ปัตตานี (Pattani)</option>
														<option value="พระนครศรีอยุธยา">พระนครศรีอยุธยา (Phra Nakhon Si Ayutthaya)</option>
														<option value="พะเยา">พะเยา (Phayao)</option>
														<option value="พังงา">พังงา (Phang Nga)</option>
														<option value="พัทลุง">พัทลุง (Phatthalung)</option>
														<option value="พิจิตร">พิจิตร (Phichit)</option>
														<option value="พิษณุโลก">พิษณุโลก (Phitsanulok)</option>
														<option value="ภูเก็ต">ภูเก็ต (Phuket)</option>
														<option value="มหาสารคาม">มหาสารคาม (Maha Sarakham)</option>
														<option value="มุกดาหาร">มุกดาหาร (Mukdahan)</option>
														<option value="ยะลา">ยะลา (Yala)</option>
														<option value="ยโสธร">ยโสธร (Yasothon)</option>
														<option value="ร้อยเอ็ด">ร้อยเอ็ด (Roi Et)</option>
														<option value="ระนอง">ระนอง (Ranong)</option>
														<option value="ระยอง">ระยอง (Rayong)</option>
														<option value="ราชบุรี">ราชบุรี (Ratchaburi)</option>
														<option value="ลพบุรี">ลพบุรี (Lopburi)</option>
														<option value="ลำปาง">ลำปาง (Lampang)</option>
														<option value="ลำพูน">ลำพูน (Lamphun)</option>
														<option value="ศรีสะเกษ">ศรีสะเกษ (Si Sa Ket)</option>
														<option value="สกลนคร">สกลนคร (Sakon Nakhon)</option>
														<option value="สงขลา">สงขลา (Songkhla)</option>
														<option value="สตูล">สตูล (Satun)</option>
														<option value="สมุทรปราการ">สมุทรปราการ (Samut Prakan)</option>
														<option value="สมุทรสงคราม">สมุทรสงคราม (Samut Songkhram)</option>
														<option value="สมุทรสาคร">สมุทรสาคร (Samut Sakhon)</option>
														<option value="สระบุรี">สระบุรี (Saraburi)</option>
														<option value="สระแก้ว">สระแก้ว (Sa Kaeo)</option>
														<option value="สิงห์บุรี">สิงห์บุรี (Sing Buri)</option>
														<option value="สุพรรณบุรี">สุพรรณบุรี (Suphan Buri)</option>
														<option value="สุราษฎร์ธานี">สุราษฎร์ธานี (Surat Thani)</option>
														<option value="สุรินทร์">สุรินทร์ (Surin)</option>
														<option value="สุโขทัย">สุโขทัย (Sukhothai)</option>
														<option value="หนองคาย">หนองคาย (Nong Khai)</option>
														<option value="หนองบัวลำภู">หนองบัวลำภู (Nong Bua Lamphu)</option>
														<option value="อ่างทอง">อ่างทอง (Ang Thong)</option>
														<option value="อำนาจเจริญ">อำนาจเจริญ (Amnat Charoen)</option>
														<option value="อุดรธานี">อุดรธานี (Udon Thani)</option>
														<option value="อุตรดิตถ์">อุตรดิตถ์ (Uttaradit)</option>
														<option value="อุทัยธานี">อุทัยธานี (Uthai Thani)</option>
														<option value="อุบลราชธานี">อุบลราชธานี (Ubon Ratchathani)</option>
														<option value="เชียงราย">เชียงราย (Chiang Rai)</option>
														<option value="เชียงใหม่">เชียงใหม่ (Chiang Mai)</option>
														<option value="เพชรบุรี">เพชรบุรี (Phetchaburi)</option>
														<option value="เพชรบูรณ์">เพชรบูรณ์ (Phetchabun)</option>
														<option value="เลย">เลย (Loei)</option>
														<option value="แพร่">แพร่ (Phrae)</option>
														<option value="แม่ฮ่องสอน">แม่ฮ่องสอน (Mae Hong Son)</option>
														<option value="ต่างประเทศ">ต่างประเทศ (abroad country)</option> 
                          </select>
                          <label for="current_province">{{this.currentLanguage ==='en'?'Province':'จังหวัดที่อยู่ปัจจุบัน'}}<span style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>

                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" class="form-control" v-model="runner_team" id="floatingInput">
                          <label for="floatingInput">{{this.currentLanguage ==='en'?'Team name (if any)':'ชื่อทีม(ถ้ามี หากไม่มีให้เว้นว่าง)'}}</label>
                        </div>
                      </div>

                      <!-- custom field -->
                      <div class="col-sm-12 col-lg-6 col-xl-4" v-if="this.event_register.is_custom_field1==='Y'">
                        <div class="form-floating mb-3">
                          <input type="text" maxlength="50" :required="this.event_register.is_custom_field1_require==='Y'" class="form-control" v-model="custom_field1" id="floatingInput">
                          <label for="floatingInput">{{this.currentLanguage ==='en'?this.event_register.is_custom_field1_name_en:this.event_register.is_custom_field1_name}}<span v-if="this.event_register.is_custom_field1_require==='Y'" style="color: red;font-size: large;">*</span></label>
                        </div>
                      </div>

                      <!-- custom field -->


                      <div class="col-sm-12 col-lg-6 col-xl-4" v-if="this.event_register.is_additional1==='Y'" >
                        <div class="form-floating mb-3" v-for="(item, index) in this.event_register.additional1" :key="index" >
                          <select class="form-select" :required="this.event_register.is_additional1_require==='Y'" id="floatingSelect" v-model="additional1"
                            aria-label="Floating label select example">
                            <option v-for="(sub_item, sub_index) in this.event_register.additional1_list" :key="sub_index"
                              :value="sub_item.id">> {{ sub_item.name }}</option>
                          </select>
                          <label for="floatingSelect">{{ item.name }}<span v-if="this.event_register.is_additional1_require === 'Y'" style="color: red;font-size: large;">*</span></label>
                          
                        </div>
                      </div>

                      <div class="col-sm-12 col-lg-6 col-xl-4" v-if="this.event_register.is_additional2==='Y'" >
                        <div class="form-floating mb-3" v-for="(item, index) in this.event_register.additional2" :key="index" >
                          <select class="form-select" :required="this.event_register.is_additional2_require==='Y'" id="floatingSelect" v-model="additional2"
                            aria-label="Floating label select example">
                            <option v-for="(sub_item, sub_index) in this.event_register.additional2_list" :key="sub_index"
                              :value="sub_item.id">> {{ sub_item.name }}</option>
                          </select>
                          <label for="floatingSelect">{{ item.name }}</label>
                        </div>
                      </div>

                      <div class="col-sm-12 col-lg-6 col-xl-4" v-if="this.event_register.is_additional3==='Y'" >
                        <div class="form-floating mb-3" v-for="(item, index) in this.event_register.additional3" :key="index" >
                          <select class="form-select" :required="this.event_register.is_additional3_require==='Y'" id="floatingSelect" v-model="additional3"
                            aria-label="Floating label select example">
                            <option v-for="(sub_item, sub_index) in this.event_register.additional3_list" :key="sub_index"
                              :value="sub_item.id">> {{ sub_item.name }}</option>
                          </select>
                          <label for="floatingSelect">{{ item.name }}</label>
                        </div>
                      </div>

                      <div class="col-sm-12 col-lg-6 col-xl-4" v-if="this.event_register.is_additional4==='Y'" >
                        <div class="form-floating mb-3" v-for="(item, index) in this.event_register.additional4" :key="index" >
                          <select class="form-select" :required="this.event_register.is_additional4_require==='Y'" id="floatingSelect" v-model="additional4"
                            aria-label="Floating label select example">
                            <option v-for="(sub_item, sub_index) in this.event_register.additional4_list" :key="sub_index"
                              :value="sub_item.id">> {{ sub_item.name }}</option>
                          </select>
                          <label for="floatingSelect">{{ item.name }}</label>
                        </div>
                      </div>

                      <!-- additional -->
                      <!-- <div class="col-sm-12 col-lg-6 col-xl-4" v-for="(this.item, index) in this.event_register.additional" :key="index" >
                        <div class="form-floating mb-3">xxxxxxxxxxx{{ item.name_key	 }}
                          <select class="form-select" :required="item.is_require==='Y'" id="floatingSelect" v-model="item.name_key"
                            aria-label="Floating label select example">
                            <option v-for="(sub_item, sub_index) in item.list" :key="sub_index"
                              :value="sub_item.id">> {{ sub_item.name }}</option>
                          </select>
                          <label for="floatingSelect">{{ item.name }}</label>
                        </div>
                      </div> -->

                      <!-- addd -->
                    </div>
                    <p>&nbsp;</p>
                    <!-- การสมัครแบบทีม คนที่ 2-->
                     <div class="row" v-if="false">
                      <b>สมาชิกในทีม คนที่2</b>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="3" maxlength="40"  required v-model="t2_fname" class="form-control" id="fname">
                          <label for="fname">{{this.currentLanguage ==='en'?'Name':'ชื่อ'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="3" maxlength="40" required v-model="t2_lname" class="form-control" id="lname">
                          <label for="lname">{{this.currentLanguage ==='en'?'Last Name':'นามสกุล'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t2_sex" id="sex" aria-label="Floating label select example">
                            <option value="MALE">{{this.currentLanguage ==='en'?'MALE':'ชาย'}}</option>
                            <option value="FEMALE">{{this.currentLanguage ==='en'?'FEMALE':'หญิง'}}</option>
                          </select>
                          <label for="sex">{{this.currentLanguage ==='en'?'Gender':'เพศ'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-1">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t2_dobd" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="01" selected>1</option>
                            <option value="02">2</option>
                            <option value="03">3</option>
                            <option value="04">4</option>
                            <option value="05">5</option>
                            <option value="06">6</option>
                            <option value="07">7</option>
                            <option value="08">8</option>
                            <option value="09">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                            <option value="24">24</option>
                            <option value="25">25</option>
                            <option value="26">26</option>
                            <option value="27">27</option>
                            <option value="28">28</option>
                            <option value="29">29</option>
                            <option value="30">30</option>
                            <option value="31">31</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Date of Birth':'วันเกิด'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-2">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t2_dobm" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="01" selected>{{this.currentLanguage ==='en'?'January':'มกราคม'}}</option>
                            <option value="02">{{this.currentLanguage ==='en'?'February':'กุมภาพันธ์'}}</option>
                            <option value="03">{{this.currentLanguage ==='en'?'March':'มีนาคม'}}</option>
                            <option value="04">{{this.currentLanguage ==='en'?'April':'เมษายน'}}</option>
                            <option value="05">{{this.currentLanguage ==='en'?'May':'พฤษภาคม'}}</option>
                            <option value="06">{{this.currentLanguage ==='en'?'June':'มิถุนายน'}}</option>
                            <option value="07">{{this.currentLanguage ==='en'?'July':'กรกฎาคม'}}</option>
                            <option value="08">{{this.currentLanguage ==='en'?'August':'สิงหาคม'}}</option>
                            <option value="09">{{this.currentLanguage ==='en'?'September':'กันยายน'}}</option>
                            <option value="10">{{this.currentLanguage ==='en'?'October':'ตุลาคม'}}</option>
                            <option value="11">{{this.currentLanguage ==='en'?'November':'พฤศจิกายน'}}</option>
                            <option value="12">{{this.currentLanguage ==='en'?'December':'ธันวาคม'}}</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Month':'เดือนเกิด'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-1">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t2_doby" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="1934">พ.ศ. 2477</option>
                            <option value="1935">พ.ศ. 2478</option>
                            <option value="1936">พ.ศ. 2479</option>
                            <option value="1937">พ.ศ. 2480</option>
                            <option value="1938">พ.ศ. 2481</option>
                            <option value="1939">พ.ศ. 2482</option>
                            <option value="1940">พ.ศ. 2483</option>
                            <option value="1941">พ.ศ. 2484</option>
                            <option value="1942">พ.ศ. 2485</option>
                            <option value="1943">พ.ศ. 2486</option>
                            <option value="1944">พ.ศ. 2487</option>
                            <option value="1945">พ.ศ. 2488</option>
                            <option value="1946">พ.ศ. 2489</option>
                            <option value="1947">พ.ศ. 2490</option>
                            <option value="1948">พ.ศ. 2491</option>
                            <option value="1949">พ.ศ. 2492</option>
                            <option value="1950">พ.ศ. 2493</option>
                            <option value="1951">พ.ศ. 2494</option>
                            <option value="1952">พ.ศ. 2495</option>
                            <option value="1953">พ.ศ. 2496</option>
                            <option value="1954">พ.ศ. 2497</option>
                            <option value="1955">พ.ศ. 2498</option>
                            <option value="1956">พ.ศ. 2499</option>
                            <option value="1957">พ.ศ. 2500</option>
                            <option value="1958">พ.ศ. 2501</option>
                            <option value="1959">พ.ศ. 2502</option>
                            <option value="1960">พ.ศ. 2503</option>
                            <option value="1961">พ.ศ. 2504</option>
                            <option value="1962">พ.ศ. 2505</option>
                            <option value="1963">พ.ศ. 2506</option>
                            <option value="1964">พ.ศ. 2507</option>
                            <option value="1965">พ.ศ. 2508</option>
                            <option value="1966">พ.ศ. 2509</option>
                            <option value="1967">พ.ศ. 2510</option>
                            <option value="1968">พ.ศ. 2511</option>
                            <option value="1969">พ.ศ. 2512</option>
                            <option value="1970">พ.ศ. 2513</option>
                            <option value="1971">พ.ศ. 2514</option>
                            <option value="1972">พ.ศ. 2515</option>
                            <option value="1973">พ.ศ. 2516</option>
                            <option value="1974">พ.ศ. 2517</option>
                            <option value="1975">พ.ศ. 2518</option>
                            <option value="1976">พ.ศ. 2519</option>
                            <option value="1977">พ.ศ. 2520</option>
                            <option value="1978">พ.ศ. 2521</option>
                            <option value="1979">พ.ศ. 2522</option>
                            <option value="1980">พ.ศ. 2523</option>
                            <option value="1981">พ.ศ. 2524</option>
                            <option value="1982">พ.ศ. 2525</option>
                            <option value="1983">พ.ศ. 2526</option>
                            <option value="1984">พ.ศ. 2527</option>
                            <option value="1985">พ.ศ. 2528</option>
                            <option value="1986">พ.ศ. 2529</option>
                            <option value="1987">พ.ศ. 2530</option>
                            <option value="1988">พ.ศ. 2531</option>
                            <option value="1989">พ.ศ. 2532</option>
                            <option value="1990">พ.ศ. 2533</option>
                            <option value="1991">พ.ศ. 2534</option>
                            <option value="1992">พ.ศ. 2535</option>
                            <option value="1993">พ.ศ. 2536</option>
                            <option value="1994">พ.ศ. 2537</option>
                            <option value="1995">พ.ศ. 2538</option>
                            <option value="1996">พ.ศ. 2539</option>
                            <option value="1997">พ.ศ. 2540</option>
                            <option value="1998">พ.ศ. 2541</option>
                            <option value="1999">พ.ศ. 2542</option>
                            <option value="2000">พ.ศ. 2543</option>
                            <option value="2001">พ.ศ. 2544</option>
                            <option value="2002">พ.ศ. 2545</option>
                            <option value="2003">พ.ศ. 2546</option>
                            <option value="2004">พ.ศ. 2547</option>
                            <option value="2005">พ.ศ. 2548</option>
                            <option value="2006">พ.ศ. 2549</option>
                            <option value="2007">พ.ศ. 2550</option>
                            <option value="2008">พ.ศ. 2551</option>
                            <option value="2009">พ.ศ. 2552</option>
                            <option value="2010">พ.ศ. 2553</option>
                            <option value="2011">พ.ศ. 2554</option>
                            <option value="2012">พ.ศ. 2555</option>
                            <option value="2013">พ.ศ. 2556</option>
                            <option value="2014">พ.ศ. 2557</option>
                            <option value="2015">พ.ศ. 2558</option>
                            <option value="2016">พ.ศ. 2559</option>
                            <option value="2017">พ.ศ. 2560</option>
                            <option value="2018">พ.ศ. 2561</option>
                            <option value="2019">พ.ศ. 2562</option>
                            <option value="2020">พ.ศ. 2563</option>
                            <option value="2021">พ.ศ. 2564</option>
                            <option value="2022">พ.ศ. 2565</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Year(BE)':'ปีเกิด'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" required class="form-control" minlength="5" maxlength="20" v-model="t2_id_card" 
                            id="floatingInput">
                          <label for="floatingInput">{{this.currentLanguage ==='en'?'ID card/Passport':'เลขบัตรประชาชน/พาสปอร์ต'}}{{ this.event_register.validate_idcard }}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" required autocomplete="off" inputmode="numeric" class="form-control" minlength="10" maxlength="10"  v-model="t2_mobile_no" id="floatingInput">
                          <label for="floatingInput">{{this.currentLanguage ==='en'?'Mobile number':'หมายเลขโทรศัพท์'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t2_blood_group" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="AB">AB</option>
                            <option value="O">O</option>
                            <option value="OTHER">Other</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Blood group':'หมู่เลือด'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelect" v-model="t2_t_shirt"
                            aria-label="Floating label select example">
                            <option v-for="(t_shirt_type, index) in this.event_register.t_shirt" :key="index"
                              :value="t_shirt_type.id">> {{ t_shirt_type.name }}"</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Shirt size':'ขนาดเสื้อ'}}</label>
                        </div>
                      </div>
                     
                      <p>&nbsp;</p>
                      
                      <b>สมาชิกในทีม คนที่3</b>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="3" maxlength="40"  required v-model="t3_fname" class="form-control" id="fname">
                          <label for="fname">{{this.currentLanguage ==='en'?'Name':'ชื่อ'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" minlength="3" maxlength="40" required v-model="t3_lname" class="form-control" id="lname">
                          <label for="lname">{{this.currentLanguage ==='en'?'Last Name':'นามสกุล'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t3_sex" id="sex" aria-label="Floating label select example">
                            <option value="MALE">{{this.currentLanguage ==='en'?'MALE':'ชาย'}}</option>
                            <option value="FEMALE">{{this.currentLanguage ==='en'?'FEMALE':'หญิง'}}</option>
                          </select>
                          <label for="sex">{{this.currentLanguage ==='en'?'Gender':'เพศ'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-1">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t3_dobd" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="01" selected>1</option>
                            <option value="02">2</option>
                            <option value="03">3</option>
                            <option value="04">4</option>
                            <option value="05">5</option>
                            <option value="06">6</option>
                            <option value="07">7</option>
                            <option value="08">8</option>
                            <option value="09">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                            <option value="21">21</option>
                            <option value="22">22</option>
                            <option value="23">23</option>
                            <option value="24">24</option>
                            <option value="25">25</option>
                            <option value="26">26</option>
                            <option value="27">27</option>
                            <option value="28">28</option>
                            <option value="29">29</option>
                            <option value="30">30</option>
                            <option value="31">31</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Date of Birth':'วันเกิด'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-2">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t3_dobm" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="01" selected>{{this.currentLanguage ==='en'?'January':'มกราคม'}}</option>
                            <option value="02">{{this.currentLanguage ==='en'?'February':'กุมภาพันธ์'}}</option>
                            <option value="03">{{this.currentLanguage ==='en'?'March':'มีนาคม'}}</option>
                            <option value="04">{{this.currentLanguage ==='en'?'April':'เมษายน'}}</option>
                            <option value="05">{{this.currentLanguage ==='en'?'May':'พฤษภาคม'}}</option>
                            <option value="06">{{this.currentLanguage ==='en'?'June':'มิถุนายน'}}</option>
                            <option value="07">{{this.currentLanguage ==='en'?'July':'กรกฎาคม'}}</option>
                            <option value="08">{{this.currentLanguage ==='en'?'August':'สิงหาคม'}}</option>
                            <option value="09">{{this.currentLanguage ==='en'?'September':'กันยายน'}}</option>
                            <option value="10">{{this.currentLanguage ==='en'?'October':'ตุลาคม'}}</option>
                            <option value="11">{{this.currentLanguage ==='en'?'November':'พฤศจิกายน'}}</option>
                            <option value="12">{{this.currentLanguage ==='en'?'December':'ธันวาคม'}}</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Month':'เดือนเกิด'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-1">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t3_doby" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="1934">พ.ศ. 2477</option>
                            <option value="1935">พ.ศ. 2478</option>
                            <option value="1936">พ.ศ. 2479</option>
                            <option value="1937">พ.ศ. 2480</option>
                            <option value="1938">พ.ศ. 2481</option>
                            <option value="1939">พ.ศ. 2482</option>
                            <option value="1940">พ.ศ. 2483</option>
                            <option value="1941">พ.ศ. 2484</option>
                            <option value="1942">พ.ศ. 2485</option>
                            <option value="1943">พ.ศ. 2486</option>
                            <option value="1944">พ.ศ. 2487</option>
                            <option value="1945">พ.ศ. 2488</option>
                            <option value="1946">พ.ศ. 2489</option>
                            <option value="1947">พ.ศ. 2490</option>
                            <option value="1948">พ.ศ. 2491</option>
                            <option value="1949">พ.ศ. 2492</option>
                            <option value="1950">พ.ศ. 2493</option>
                            <option value="1951">พ.ศ. 2494</option>
                            <option value="1952">พ.ศ. 2495</option>
                            <option value="1953">พ.ศ. 2496</option>
                            <option value="1954">พ.ศ. 2497</option>
                            <option value="1955">พ.ศ. 2498</option>
                            <option value="1956">พ.ศ. 2499</option>
                            <option value="1957">พ.ศ. 2500</option>
                            <option value="1958">พ.ศ. 2501</option>
                            <option value="1959">พ.ศ. 2502</option>
                            <option value="1960">พ.ศ. 2503</option>
                            <option value="1961">พ.ศ. 2504</option>
                            <option value="1962">พ.ศ. 2505</option>
                            <option value="1963">พ.ศ. 2506</option>
                            <option value="1964">พ.ศ. 2507</option>
                            <option value="1965">พ.ศ. 2508</option>
                            <option value="1966">พ.ศ. 2509</option>
                            <option value="1967">พ.ศ. 2510</option>
                            <option value="1968">พ.ศ. 2511</option>
                            <option value="1969">พ.ศ. 2512</option>
                            <option value="1970">พ.ศ. 2513</option>
                            <option value="1971">พ.ศ. 2514</option>
                            <option value="1972">พ.ศ. 2515</option>
                            <option value="1973">พ.ศ. 2516</option>
                            <option value="1974">พ.ศ. 2517</option>
                            <option value="1975">พ.ศ. 2518</option>
                            <option value="1976">พ.ศ. 2519</option>
                            <option value="1977">พ.ศ. 2520</option>
                            <option value="1978">พ.ศ. 2521</option>
                            <option value="1979">พ.ศ. 2522</option>
                            <option value="1980">พ.ศ. 2523</option>
                            <option value="1981">พ.ศ. 2524</option>
                            <option value="1982">พ.ศ. 2525</option>
                            <option value="1983">พ.ศ. 2526</option>
                            <option value="1984">พ.ศ. 2527</option>
                            <option value="1985">พ.ศ. 2528</option>
                            <option value="1986">พ.ศ. 2529</option>
                            <option value="1987">พ.ศ. 2530</option>
                            <option value="1988">พ.ศ. 2531</option>
                            <option value="1989">พ.ศ. 2532</option>
                            <option value="1990">พ.ศ. 2533</option>
                            <option value="1991">พ.ศ. 2534</option>
                            <option value="1992">พ.ศ. 2535</option>
                            <option value="1993">พ.ศ. 2536</option>
                            <option value="1994">พ.ศ. 2537</option>
                            <option value="1995">พ.ศ. 2538</option>
                            <option value="1996">พ.ศ. 2539</option>
                            <option value="1997">พ.ศ. 2540</option>
                            <option value="1998">พ.ศ. 2541</option>
                            <option value="1999">พ.ศ. 2542</option>
                            <option value="2000">พ.ศ. 2543</option>
                            <option value="2001">พ.ศ. 2544</option>
                            <option value="2002">พ.ศ. 2545</option>
                            <option value="2003">พ.ศ. 2546</option>
                            <option value="2004">พ.ศ. 2547</option>
                            <option value="2005">พ.ศ. 2548</option>
                            <option value="2006">พ.ศ. 2549</option>
                            <option value="2007">พ.ศ. 2550</option>
                            <option value="2008">พ.ศ. 2551</option>
                            <option value="2009">พ.ศ. 2552</option>
                            <option value="2010">พ.ศ. 2553</option>
                            <option value="2011">พ.ศ. 2554</option>
                            <option value="2012">พ.ศ. 2555</option>
                            <option value="2013">พ.ศ. 2556</option>
                            <option value="2014">พ.ศ. 2557</option>
                            <option value="2015">พ.ศ. 2558</option>
                            <option value="2016">พ.ศ. 2559</option>
                            <option value="2017">พ.ศ. 2560</option>
                            <option value="2018">พ.ศ. 2561</option>
                            <option value="2019">พ.ศ. 2562</option>
                            <option value="2020">พ.ศ. 2563</option>
                            <option value="2021">พ.ศ. 2564</option>
                            <option value="2022">พ.ศ. 2565</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Year(BE)':'ปีเกิด'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" required class="form-control" minlength="5" maxlength="20" v-model="t3_id_card" 
                            id="floatingInput">
                          <label for="floatingInput">{{this.currentLanguage ==='en'?'ID card/Passport':'เลขบัตรประชาชน/พาสปอร์ต'}}{{ this.event_register.validate_idcard }}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input type="text" required autocomplete="off" inputmode="numeric" class="form-control" minlength="10" maxlength="10"  v-model="t3_mobile_no" id="floatingInput">
                          <label for="floatingInput">{{this.currentLanguage ==='en'?'Mobile number':'หมายเลขโทรศัพท์'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required v-model="t3_blood_group" id="floatingSelect"
                            aria-label="Floating label select example">
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="AB">AB</option>
                            <option value="O">O</option>
                            <option value="OTHER">Other</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Blood group':'หมู่เลือด'}}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select class="form-select" required id="floatingSelect" v-model="t3_t_shirt"
                            aria-label="Floating label select example">
                            <option v-for="(t_shirt_type, index) in this.event_register.t_shirt" :key="index"
                              :value="t_shirt_type.id">> {{ t_shirt_type.name }}"</option>
                          </select>
                          <label for="floatingSelect">{{this.currentLanguage ==='en'?'Shirt size':'ขนาดเสื้อ'}}</label>
                        </div>
                      </div>
                    </div>
                    <div v-for="(member, index) in teamMembers" :key="`team-member-${index}`" class="row team-member-form">
                      <b>{{ currentLanguage === 'en' ? `Team member ${index + 2}` : `สมาชิกในทีม คนที่${index + 2}` }}</b>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input :id="`team-fname-${index}`" v-model="member.fname" type="text" minlength="3" maxlength="40" required class="form-control">
                          <label :for="`team-fname-${index}`">{{ currentLanguage === 'en' ? 'Name' : 'ชื่อ' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input :id="`team-lname-${index}`" v-model="member.lname" type="text" minlength="3" maxlength="40" required class="form-control">
                          <label :for="`team-lname-${index}`">{{ currentLanguage === 'en' ? 'Last Name' : 'นามสกุล' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select :id="`team-sex-${index}`" v-model="member.sex" required class="form-select">
                            <option value="MALE">{{ currentLanguage === 'en' ? 'MALE' : 'ชาย' }}</option>
                            <option value="FEMALE">{{ currentLanguage === 'en' ? 'FEMALE' : 'หญิง' }}</option>
                          </select>
                          <label :for="`team-sex-${index}`">{{ currentLanguage === 'en' ? 'Gender' : 'เพศ' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-1">
                        <div class="form-floating mb-3">
                          <select :id="`team-dobd-${index}`" v-model="member.dobd" required class="form-select">
                            <option v-for="day in teamBirthDays" :key="day" :value="day">{{ Number(day) }}</option>
                          </select>
                          <label :for="`team-dobd-${index}`">{{ currentLanguage === 'en' ? 'Date of Birth' : 'วันเกิด' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-2">
                        <div class="form-floating mb-3">
                          <select :id="`team-dobm-${index}`" v-model="member.dobm" required class="form-select">
                            <option v-for="month in teamBirthMonths" :key="month.value" :value="month.value">{{ currentLanguage === 'en' ? month.en : month.th }}</option>
                          </select>
                          <label :for="`team-dobm-${index}`">{{ currentLanguage === 'en' ? 'Month' : 'เดือนเกิด' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-1">
                        <div class="form-floating mb-3">
                          <select :id="`team-doby-${index}`" v-model="member.doby" required class="form-select">
                            <option v-for="year in teamBirthYears" :key="year" :value="year">พ.ศ. {{ Number(year) + 543 }}</option>
                          </select>
                          <label :for="`team-doby-${index}`">{{ currentLanguage === 'en' ? 'Year (BE)' : 'ปีเกิด' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input :id="`team-id-card-${index}`" v-model="member.id_card" type="text" minlength="5" maxlength="20" required class="form-control" @input="member.id_card = member.id_card.replace(/[^a-zA-Z0-9]/g, '')">
                          <label :for="`team-id-card-${index}`">{{ currentLanguage === 'en' ? 'ID card/Passport' : 'เลขบัตรประชาชน/พาสปอร์ต' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <input :id="`team-mobile-${index}`" v-model="member.mobile_no" type="text" minlength="10" maxlength="10" autocomplete="off" inputmode="numeric" required class="form-control" @input="member.mobile_no = member.mobile_no.replace(/[^0-9]/g, '')">
                          <label :for="`team-mobile-${index}`">{{ currentLanguage === 'en' ? 'Mobile number' : 'หมายเลขโทรศัพท์' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select :id="`team-blood-${index}`" v-model="member.blood_group" required class="form-select">
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="AB">AB</option>
                            <option value="O">O</option>
                            <option value="OTHER">Other</option>
                          </select>
                          <label :for="`team-blood-${index}`">{{ currentLanguage === 'en' ? 'Blood group' : 'หมู่เลือด' }}</label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-lg-6 col-xl-4">
                        <div class="form-floating mb-3">
                          <select :id="`team-shirt-${index}`" v-model="member.t_shirt_id" required class="form-select">
                            <option v-for="shirt in event_register.t_shirt.filter(item => item.run_type_id === 0 || item.run_type_id === run_type)" :key="shirt.id" :value="shirt.id">{{ shirt.name }}</option>
                          </select>
                          <label :for="`team-shirt-${index}`">{{ currentLanguage === 'en' ? 'Shirt size' : 'ขนาดเสื้อ' }}</label>
                        </div>
                      </div>
                    </div>
                    <!-- การสมัครแบบทีม -->
                    <div class="row">
                      <div class="d-flex justify-content-center">
                        <button v-if="this.runner_action === 'EDIT'" type="submit" style="cursor: pointer"
                          class="btn btn-primary btn-lg"> {{this.currentLanguage ==='en'?'Update':'อัปเดทข้อมูลผู้สมัคร'}} </button>
                        <button v-if="this.runner_action === 'ADD'" type="submit" style="cursor: pointer"
                          :disabled="this.is_add_runner === 'Y' || this.event_register.max_runner_register_per_order === this.runnerList.length"
                          class="btn btn-primary btn-lg" >
                          <span v-if="this.is_add_runner === 'Y'" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          {{ this.is_add_runner === 'Y' ? (this.currentLanguage === 'en' ? 'Adding runner...' : 'กำลังเพิ่มข้อมูลผู้สมัคร...') : (this.currentLanguage === 'en' ? 'Add' : 'เพิ่มข้อมูลผู้สมัคร') }}
                        </button> &nbsp;
                        <button style="cursor: pointer" type="reset" @click.prevent="clear" :disabled="this.is_add_runner === 'Y'"
                          class="btn btn-secondary btn-lg"> {{this.currentLanguage ==='en'?'Cancel':'ยกเลิก'}}</button>
                      </div>
                    </div>
                    <p v-if="this.event_register.special_register_remark && this.currentLanguage ==='th'" style="color: red;">&nbsp;{{ this.event_register.special_register_remark }}</p>
                    <p v-else-if="this.currentLanguage ==='th'" style="color: red;">*สามารถเพิ่มผู้สมัครได้สูงสุดไม่เกิน {{ this.event_register.max_runner_register_per_order }} คน</p>
                    <p v-if="this.event_register.special_register_remark_en && this.currentLanguage ==='en'" style="color: red;">&nbsp;{{ this.event_register.special_register_remark_en }}</p>
                    <p v-else-if="this.currentLanguage ==='en'" style="color: red;">*You can register up to a maximum of {{ this.event_register.max_runner_register_per_order }} participants.</p>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <form @submit.prevent="create_order" @beforeinput.capture="blockForbiddenCharacters" @paste.capture="blockForbiddenPaste" class="needs-validation">
            <div class="col-sm-12" >
            
              <div class="card">
                <div class="card-header">
                  
                  <h5 v-if="this.runnerList.length <= 0" style="color: red;text-align: center;"><br>{{this.currentLanguage ==='en'?'Fill runner infomation then press "Add"':'ป้อนข้อมูลส่วนตัวผู้สมัคร แล้วกด "เพิ่มข้อมูลผู้สมัคร"'}} <br><br></h5>
                  <h5 v-if="this.runnerList.length > 0">{{this.currentLanguage ==='en'?'Number of applicants information':'ข้อมูลผู้สมัครจำนวน'}} {{ this.runnerList.length }} {{this.currentLanguage ==='en'?'items':'คน'}}</h5>
                  <div class="row">

                    <div class="card" style="width: 18rem;" v-for="(item, index) in this.runnerList" :key="index"
                      :value="item.id_card">
                      <div style="text-align: right;"><button type="button" class="btn-close float-right"
                          @click.prevent="runner_delete(item.id_card, item.fname)" aria-label="Close"></button></div>
                      <div style="text-align: left;">
                        <input class="form-check-input" @click="select_main_register(item.id_card); clearValidationErrors()"
                          v-model="is_main_register" required type="radio" name="is_main_register"
                          :id="'is_main_register' + item.id_card" :value="item.id_card">
                        <label class="form-check-label" :for="'is_main_register' + item.id_card">
                          <h5>&nbsp;{{this.currentLanguage ==='en'?'Main register':'ผู้สมัครหลัก'}}</h5>
                        </label>
                      </div>
                        <img v-if="item.sex==='MALE'" src="../../assets/images/runner.jpg" class="card-img-top" alt="runner">
                        <img v-if="item.sex==='FEMALE'" src="../../assets/images/runner-girl.jpg" class="card-img-top" alt="runner">
                      <div class="card-body">
                        <h5 class="card-title">{{ item.fname }} {{ item.lname }}</h5>
                        <p class="card-text">{{ item.run_type_name }}<br> {{ item.run_type_price + item.t_shirt_additional_price + Number(item.t_shirt_more_additional_price || 0) }} THB <br> {{item.run_type_description }}

                        </p>
                        <p>
                          <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                            :data-bs-target="'#' + item.id_card"> {{this.currentLanguage ==='en'?'More':'เพิ่มเติม'}} </button> &nbsp;
                          <button type="button" class="btn btn-light btn-sm" v-if="this.event_register.payment_method !== 'FREE'" @click.prevent="runner_edit(item.id_card)">
                            {{this.currentLanguage ==='en'?'Edit':'แก้ไข'}} </button>
                        </p>

                        <div class="modal fade" :id="item.id_card" tabindex="-1" :aria-labelledby="item.id_card"
                          aria-hidden="true">
                          <div class="modal-dialog">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h1 class="modal-title fs-5" :id="item.id_card">{{ item.fname }} {{ item.lname }}</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div class="modal-body">
                                &nbsp;&nbsp;&nbsp;กรุณากดปุ่มลงทะเบียนด้านล่างเพื่อยืนยันการสมัครเข้าร่วมกิจกรรมนี้!<br><br />
                                .<br>
                                {{this.currentLanguage ==='en'?'name':'ชื่อ'}}: {{ item.fname }} {{ item.lname }} <br>
                                {{this.currentLanguage ==='en'?'gender':'เพศ'}}: {{ item.sex }} <br>
                                {{this.currentLanguage ==='en'?'dob':'วันเกิด'}}: {{ item.dob }} <br>
                                {{this.currentLanguage ==='en'?'nationality':'สัญชาติ'}}: {{ item.nationality }} <br>
                                {{this.currentLanguage ==='en'?'id card/Passport':'เลขบัตรประชาชน/พาสปอร์ต'}}: {{ item.id_card }} <br>
                                {{this.currentLanguage ==='en'?'mobile no':'หมายเลขโทรศัพท์'}}: {{ item.mobile_no }} <br>
                                {{this.currentLanguage ==='en'?'email':'อีเมลล์'}}: {{ item.email }} <br>
                                {{this.currentLanguage ==='en'?'blood type':'หมู่เลือด'}}: {{ item.blood_group }} <br>
                                {{this.currentLanguage ==='en'?'emergency contact name':'ชื่อผู้ติดต่อกรณีฉุกเฉิน'}}: {{ item.emergency_name }} <br>
                                {{this.currentLanguage ==='en'?'relationship':'ความสัมพันธ์'}}: {{ item.emergency_relation }} <br>
                                {{this.currentLanguage ==='en'?'emergency contact mobile number':'เบอร์โทรศัพท์ผู้ติดต่อกรณีฉุกเฉิน'}}: {{ item.emergency_mobile_no }} <br>
                                {{this.currentLanguage ==='en'?'Type':'ประเภทการเเข่งขัน'}}: {{ item.run_type_name }}, {{ item.run_type_description }}, {{ item.run_type_price }} <br>

                                {{this.currentLanguage ==='en'?'Group':'รูปแบบการแข่งขัน'}}: {{ item.run_model_name }} <br>
                                {{this.currentLanguage ==='en'?'Province':'จังหวัดที่อยู่ปัจจุบัน'}}: {{ item.current_province }}<br>
                                {{this.currentLanguage ==='en'?'Team':'ชื่อทีม'}}: {{ item.runner_team }} <br>
                                {{this.currentLanguage ==='en'?'Shirt size':'ขนาดเสื้อ'}}: {{ item.t_shirt_name }}<br>
                                <span v-if="item.t_shirt_more_name">{{this.currentLanguage ==='en'?'Second shirt size':'ขนาดเสื้อตัวที่สอง'}}: {{ item.t_shirt_more_name }}<br></span>
                                
                                <span v-if="this.event_register.is_custom_field1==='Y'">{{this.currentLanguage ==='en'?this.event_register.is_custom_field1_name_en:this.event_register.is_custom_field1_name}}: {{ item.custom_field1 }}</span><br>
                                {{this.currentLanguage ==='en'?'more':'เพิ่มเติม'}}: {{ item.additional1_name }}<br>
                                {{this.currentLanguage ==='en'?'more':'เพิ่มเติม'}}: {{ item.additional2_name }}<br>
                                <div v-if="getTeamMemberDetails(item.team_member_obj).length > 0" class="mt-3 pt-3 border-top">
                                  <b>{{ currentLanguage === 'en' ? 'Team members' : 'สมาชิกในทีม' }}</b>
                                  <div v-for="(member, memberIndex) in getTeamMemberDetails(item.team_member_obj)" :key="`team-member-detail-${memberIndex}`" class="mt-2">
                                    <b>{{ currentLanguage === 'en' ? `Team member ${memberIndex + 2}` : `สมาชิกในทีม คนที่${memberIndex + 2}` }}</b><br>
                                    {{ currentLanguage === 'en' ? 'Name' : 'ชื่อ' }}: {{ member.fname }} {{ member.lname }}<br>
                                    {{ currentLanguage === 'en' ? 'Gender' : 'เพศ' }}: {{ member.sex }}<br>
                                    {{ currentLanguage === 'en' ? 'Date of birth' : 'วันเกิด' }}: {{ member.dob }}<br>
                                    {{ currentLanguage === 'en' ? 'ID card/Passport' : 'เลขบัตรประชาชน/พาสปอร์ต' }}: {{ member.id_card }}<br>
                                    {{ currentLanguage === 'en' ? 'Mobile number' : 'หมายเลขโทรศัพท์' }}: {{ member.mobile_no }}<br>
                                    {{ currentLanguage === 'en' ? 'Blood group' : 'หมู่เลือด' }}: {{ member.blood_group }}<br>
                                    {{ currentLanguage === 'en' ? 'Shirt size' : 'ขนาดเสื้อ' }}: {{ member.t_shirt_name }}<br>
                                  </div>
                                </div>
                                
                                
                                <!-- เพิ่มเติม: {{ item.additional3_name }}<br>
                                เพิ่มเติม: {{ item.additional4_name }}<br> -->
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>


                    <div class="card" style="width: 18rem;" v-if="this.runnerList.length <= 0" >
                      <div style="text-align: right;"></div>
                      <div style="text-align: left;">
                        <label class="form-check-label" >
                          <p>&nbsp;{{this.currentLanguage ==='en'?'........':'........'}}</p>
                        </label>
                      </div>

                      <img src="../../assets/images/runner-disable.jpg" class="card-img-top" alt="runner">
                      <div class="card-body">
                        <h5 class="card-title">......</h5>
                        <p class="card-text">____<br> ____ <br>____

                        </p>
                        <p>
                          <button type="button" class="btn btn-primary btn-sm" disabled>{{this.currentLanguage ==='en'?'More':'เพิ่มเติม'}} </button> &nbsp;
                          <button type="button" class="btn btn-light btn-sm" disabled v-if="this.event_register.payment_method !== 'FREE'"> {{this.currentLanguage ==='en'?'Edit':'แก้ไข'}} </button>
                        </p>

                        
                      </div>
                    </div>

                  </div>


                  <h4> {{this.currentLanguage ==='en'?'Race Kit Pickup':'การรับเสื้อและบิบ'}}<span style="color: red;font-size: large;">*</span></h4>
                  <div class="form-check form-check-inline" v-for="(item, index) in this.event_register.delivery_type"
                    :key="index" :value="item.id">

                    <input class="form-check-input" @click="delivery_type_change(item.id); clearValidationErrors()" v-model="delivery_type" required
                      type="radio" name="delivery_type_name" :id="'delivery_type' + item.id" :value="item.id">
                    <label class="form-check-label" :for="'delivery_type' + item.id">
                      <h5 v-if="this.currentLanguage ==='th'">{{ item.name }}<p style="size: 8px;color: gray;font-weight: normal;" v-html="item.description"></p></h5>
                      <h5 v-if="this.currentLanguage ==='en'">{{ item.name_en }}<p style="size: 8px;color: gray;font-weight: normal;" v-html="item.description_en"></p></h5>
                    </label>

                  </div>
                  <div class="row" v-if="this.delivery_type_is_require_address === 'Y'">
                    <b> {{this.currentLanguage ==='en'?'Address':'ที่อยู่'}}</b>
                    <div class="col-sm-12 col-lg-6 col-xl-4">
                      <div class="form-floating mb-3">
                        <input type="text" required v-model="delivery_add_name"  class="form-control"  id="floatingInput">
                        <label for="floatingInput">{{this.currentLanguage ==='en'?'First Name-Last Name':'ชื่อ-สกุล ผู้รับ'}}<span style="color: red;font-size: large;">*</span></label>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 col-xl-4">
                      <div class="form-floating mb-3">
                        <input type="text" required autocomplete="off" inputmode="numeric" v-model="delivery_add_mobile_no" class="form-control"
                          id="floatingInput">
                        <label for="floatingInput">{{this.currentLanguage ==='en'?'Mobile number':'หมายเลขโทรศัพท์'}}<span style="color: red;font-size: large;">*</span></label>
                      </div>
                    </div>

                    <div class="col-sm-12 col-lg-6 col-xl-4">
                      <div class="form-floating mb-3">
                        <input type="text" maxlength="60" required v-model="delivery_add_no" class="form-control" id="floatingInput">
                        <label for="floatingInput">{{this.currentLanguage ==='en'?'No./alley/road':'บ้านเลขที่/ซอย/ ถนน'}}<span style="color: red;font-size: large;">*</span></label>
                      </div>
                    </div>

                    <div class="col-sm-12 col-lg-6 col-xl-4">
                      <div class="form-floating mb-3">
                        <input type="number" required v-model="delivery_add_postcode" autocomplete="off" inputmode="numeric"
                          @change="load_sub_district" class="form-control" minlength="5" maxlength="5" id="floatingInput">
                        <label for="floatingInput">{{this.currentLanguage ==='en'?'postcode':'รหัสไปรษณีย์'}}<span style="color: red;font-size: large;">*</span></label>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 col-xl-4">
                      <div class="form-floating mb-3">
                        <select class="form-select" required v-model="delivery_add_sub_district" @change="load_district"
                          id="delivery_add_sub_district_id" aria-label="Floating label select example">
                          <option v-for="(sub_district, index) in this.delivery_add_sub_district_obj" :key="index"
                            :value="sub_district.ref"> {{ sub_district.name_th }}</option>
                        </select>
                        <label for="delivery_add_sub_district_id"> {{this.currentLanguage ==='en'?'Sub District':'ตำบล'}}<span style="color: red;font-size: large;">*</span></label>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-6 col-xl-4">
                      <div class="form-floating mb-3">
                        <select class="form-select" required v-model="delivery_add_district" @change="load_province"
                          id="delivery_add_district_id" aria-label="Floating label select example">
                          <option v-for="(district, index) in this.delivery_add_district_obj" :key="index"
                            :value="district.ref">
                            {{ district.name_th }}</option>
                        </select> <label for="delivery_add_district_id">{{this.currentLanguage ==='en'?'District':'อำเภอ'}}<span style="color: red;font-size: large;">*</span></label>
                      </div>
                    </div>
                    
                    <div class="col-sm-12 col-lg-6 col-xl-4">
                      <div class="form-floating mb-3">
                        <select class="form-select" required v-model="delivery_add_province" @change="load_province"
                          id="delivery_add_province_id" aria-label="Floating label select example">
                          <option v-for="(province, index) in this.delivery_add_province_obj" :key="index"
                            :value="province.ref">
                            {{ province.name }}</option>
                        </select>
                        <label for="delivery_add_province_id">{{this.currentLanguage ==='en'?'Province':'จังหวัด'}}<span style="color: red;font-size: large;">*</span></label>
                      </div>
                    </div>

                  </div>


                  <div v-if="this.event_register.payment_method !== 'DIRECT' && this.event_register.payment_method !== 'FREE'">
                    <h4>{{this.currentLanguage ==='en'?'Payment method':'ช่องทางการชำระเงิน'}}<span style="color: red;font-size: large;">*</span></h4>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" v-model="payment_method" @change="clearValidationErrors" required type="radio"
                        name="inlineRadioOptionspayment_method" id="payment_method1" :value="'PP_'+this.event_register.payment_method">
                      <label class="form-check-label" for="payment_method1">
                        <h5>{{this.currentLanguage ==='en'?'PromptPay':'พร้อมเพย์(PromptPay)'}}</h5>
                        <p v-if="this.event_register.is_free_payment_fee === 'N'" style="size: 6px;color: gray;font-weight: normal;">{{this.currentLanguage ==='en'?'Online payment fee 3%':'ค่าธรรมเนียมการชำระเงินออนไลน์ 3%'}}</p>
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" v-model="payment_method" @change="clearValidationErrors" type="radio" required
                        name="inlineRadioOptionspayment_method" id="payment_method2" :value="'CC_'+this.event_register.payment_method">
                      <label class="form-check-label" for="payment_method2">
                        <h5>{{this.currentLanguage ==='en'?'Credit Card/debit':'บัตรเครดิต/เดบิต'}}</h5>
                        <p v-if="this.event_register.is_free_payment_fee ==='N'" style="size: 6px;color: gray;font-weight: normal;">{{this.currentLanguage ==='en'?'Online payment fee 5%':'ค่าธรรมเนียมการชำระเงินออนไลน์ 5%'}}</p>
                      </label>
                    </div>
                  </div>
                  <p>&nbsp;</p>
                  <h4>{{this.currentLanguage ==='en'?'Terms and Conditions of Use':'เงื่อนไขและข้อตกลงการใช้งานการใช้งาน'}}<span style="color: red;font-size: large;">*</span></h4>


                  <!-- <div class="form-check">
                    <input class="form-check-input" required type="checkbox" value="" id="flexCheckDefault">
                    <label class="form-check-label" for="flexCheckDefault">
                      {{this.currentLanguage ==='en'?'I have verified the accuracy of the application.':'ข้าพเจ้าได้ตรวจสอบความถูกต้องของใบสมัครเรียบร้อยแล้ว'}}
                    </label>
                  </div> -->

                  <div class="form-check">
                    <input class="form-check-input" required type="checkbox" id="flexCheckChecked" v-model="terms_accepted" @change="show_terms_warning = false; clearValidationErrors()">
                    <label class="form-check-label" for="flexCheckChecked">
                    {{this.currentLanguage ==='en'?'I have understood and accepted the conditions of participation in the activity.':'ข้าพเจ้าได้ทำความเข้าใจ และยอมรับเงื่อนไขการเข้าร่วมกิจกรรม'}}
                    </label>
                  </div>
                  <div class="form-check" v-if="this.event_register.condition !== 'N'">
                    <input class="form-check-input" required  type="checkbox"  id="flexCheckChecked2" @change="clearValidationErrors">
                    <label class="form-check-label" v-if="this.currentLanguage === 'th'" for="flexCheckChecked2"  v-html="this.event_register.condition" ></label>
                    <label class="form-check-label" v-if="this.currentLanguage === 'en'" for="flexCheckChecked2"  v-html="this.event_register.condition_en" ></label>
                  </div>
                  <div class="col-sm-12" v-if="this.runnerList.length == 0">
                    <span class="col-sm-12" v-if="this.runnerList.length <= 0" style="color: red;text-align: center;"><br>{{this.currentLanguage ==='en'?'Create order button will show after filling runner information then press "Add"':'*ปุ่มสร้างออเดอร์จะแสดงเมื่อ  ป้อนข้อมูลส่วนตัวผู้สมัคร แล้วกด "เพิ่มข้อมูลผู้สมัคร" ด้านบน'}} <br><br></span>
                  </div>               
                </div>
              </div>
            </div>

            <div class="col-sm-12" v-if="this.runnerList.length > 0 && this.event_register.payment_method !== 'FREE'">
              <div class="card" v-if="this.event_register.is_coupon=== 'Y'">
                <div class="card-header">
                  <div class="row">
                    
                  <div class="col-sm-6" >
                            <div class="input-group mb-3">
                              <span class="input-group-text" id="basic-addon1">
                                <!-- {{this.currentLanguage ==='en'?'Coupon(if any)':'คูปอง(ถ้ามี)'}} -->
                              <label>{{ this.currentLanguage === 'en' ? 'Discount Code' : 'โค้ดส่วนลด' }}&nbsp;&nbsp;&nbsp;</label>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" value="Y" :disabled="this.runnerList.length > 1 || this.is_apply_coupon==='Y'" v-model="is_have_coupon">
                                <label class="form-check-label" for="YES">{{ this.currentLanguage === 'en' ? 'Y' : 'มี' }}</label>
                              </div>
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" value="N" :disabled="this.runnerList.length > 1 || this.is_apply_coupon==='Y'" v-model="is_have_coupon">
                                <label class="form-check-label" for="NO">{{ this.currentLanguage === 'en' ? 'N' : 'ไม่มี' }}</label>
                              </div>
                              </span>
                              <input type="text" :disabled="this.is_apply_coupon==='Y' || this.is_have_coupon ==='N'" placeholder="ตัวอักษรพิมพ์ใหญ่และตัวเลขเท่านั้น" v-model="coupon_code" @input="coupon_code = coupon_code.toUpperCase().replace(/[^0-9A-Z]/g, '')" autocomplete="off" inputmode="txt"  class="form-control" minlength="8" maxlength="15" id="coupon_code">
                            </div>
                  </div>
                  <div class="col-sm-6" >
                    <div class="form-floating mb-0">
                        <button v-if="this.is_apply_coupon==='N'" :disabled="this.is_have_coupon ==='N'" type="button" @click.passive="get_coupon" style="cursor: pointer" class="btn btn-primary" > ใช้คูปอง/Apply coupon</button>
                        <span v-if="this.is_apply_coupon==='Y'" style="color: green;padding-left: 10px;"><br><vue-feather stroke="green" type="check-circle" size="17"> </vue-feather>  {{this.currentLanguage ==='th'? this.coupon_obj.description:this.coupon_obj.description_en}}</span>
                        <span v-if="this.is_found_coupon==='N'" style="color: red;padding-left: 10px;"><vue-feather stroke="red" type="x-circle" size="17"> </vue-feather>  {{this.currentLanguage ==='th'? this.coupon_obj.description:this.coupon_obj.description_en}}</span>
                     </div>
                  </div>
                  </div>
                  <div class="row" v-if="this.runnerList.length > 1">
                    <span style="font-size: smaller;">โปรดลดจำนวนผู้สมัครให้เหลือ 1 คน เพื่อใช้โค้ดส่วนลด (ถ้ามี)</span>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <b>{{this.currentLanguage ==='en'?'Summary':'สรุปรายการสั่งซื้อ'}}</b>

                  <div class="table-responsive" style="margin-left: auto; margin-right: 0">
                    <table class="table align-to-right" style="width: 100%; text-align: center;padding: 0;">
                      <thead>
                        <tr class="border-bottom-light">
                          <th scope="col" style="text-align: right; width: 50%;padding: 0;">

                            {{this.currentLanguage ==='en'?'Application':'ค่าสมัคร'}}

                          </th>
                          <th scope="col" style="text-align: right;padding: 0;">
                            {{ this.total_amt }} THB
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="border-bottom-light">
                          <th style="text-align: right;padding: 0;">
                            {{this.currentLanguage ==='en'?'Shipping':'ค่าจัดส่ง'}}
                          </th>
                          <th style="text-align: right; vertical-align: bottom;padding: 0;">
                            <p >
                              {{ Number(this.delivery_type_price)+((this.runnerList.length-1)*this.delivery_type_price_addtional) }} THB
                            </p>
                          </th>
                        </tr>
                        <tr class="border-bottom-light" v-if="this.event_register.is_system_fee==='Y'">
                          <th style="text-align: right;padding: 0;">
                            {{this.currentLanguage ==='en'?'Register fee':'ค่าบริการระบบรับสมัคร'}}({{ this.runnerList.length }})
                          </th>
                          <th style="text-align: right; vertical-align: bottom;padding: 0;">
                            <p>
                              {{ this.runnerList.length*this.event_register.system_fee_amt }} THB
                            </p>
                          </th>
                        </tr>
                      </tbody>

                      <tbody>
                        <tr class="border-bottom-dark">
                          <th scope="col" style="text-align: right;padding: 0;">
                            {{this.currentLanguage ==='en'?'Total':'ยอดรวมหลังหักส่วนลด'}}
                          </th>
                          <th scope="col" style="text-align: right;padding: 0;">
                            {{ Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt) + Number(((this.runnerList.length-1)*this.delivery_type_price_addtional)) }}
                            THB
                          </th>
                        </tr>
                      </tbody>

                      <tbody>
                        <tr class="border-bottom-white">
                          <th scope="col" style="text-align: right">
                            {{this.currentLanguage ==='en'?'Online payment fee':'ค่าธรรมเนียมการชำระเงินออนไลน์'}}
                            
                          </th>
                          <th v-if="this.event_register.payment_method !== 'DIRECT'" scope="col" style="text-align: right;padding-right: 0;">
                            <p v-if="this.payment_method==='PP_OPN' && this.event_register.is_free_payment_fee === 'N'">{{ Number(Number(this.total_amt*this.payment_fee_pp) + Number(this.delivery_type_price*this.payment_fee_pp) + Number((this.runnerList.length*this.event_register.system_fee_amt)*this.payment_fee_pp)).toFixed(2) }} THB</p>
                            <p v-if="this.payment_method==='CC_OPN' && this.event_register.is_free_payment_fee === 'N'">{{ Number(Number(this.total_amt*this.payment_fee_cc) + Number(this.delivery_type_price*this.payment_fee_cc) + Number((this.runnerList.length*this.event_register.system_fee_amt)*this.payment_fee_cc)).toFixed(2) }} THB</p>
                            <p v-if="this.payment_method==='PP_OPN' && this.event_register.is_free_payment_fee === 'Y'">0 THB</p>
                            <p v-if="this.payment_method==='CC_OPN' && this.event_register.is_free_payment_fee === 'Y'">0 THB</p>
                            
                          </th>
                          <th v-if="this.event_register.payment_method === 'DIRECT' " scope="col" style="text-align: right;padding-right: 0;">
                            0 THB
                          </th>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr class="border-bottom-primary">
                          <th scope="col" style="text-align: right">
                            {{this.currentLanguage ==='en'?'Net payment':'ยอดชำระสุทธิ'}}
                          </th>
                          <th v-if="this.event_register.payment_method !== 'DIRECT'" scope="col" style="text-align: right">
                            <b v-if="this.payment_method==='PP_OPN' && this.event_register.is_free_payment_fee === 'N'" > {{ Number((Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt)) + Number(Number(this.total_amt*this.payment_fee_pp) + Number(this.delivery_type_price*this.payment_fee_pp) + Number((this.runnerList.length*this.event_register.system_fee_amt)*this.payment_fee_pp))).toFixed(2) }} THB</b>
                            <b v-if="this.payment_method==='CC_OPN' && this.event_register.is_free_payment_fee === 'N'"> {{ Number((Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt)) + Number(Number(this.total_amt*this.payment_fee_cc) + Number(this.delivery_type_price*this.payment_fee_cc) + Number((this.runnerList.length*this.event_register.system_fee_amt)*this.payment_fee_cc))).toFixed(2) }} THB</b>
                            <b v-if="this.payment_method==='PP_OPN' && this.event_register.is_free_payment_fee === 'Y'" > {{ Number((Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt))).toFixed(2) }} THB</b>
                            <b v-if="this.payment_method==='CC_OPN' && this.event_register.is_free_payment_fee === 'Y'"> {{ Number((Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt))).toFixed(2) }} THB</b>
                          </th>
                          <th v-if="this.event_register.payment_method === 'DIRECT'" scope="col" style="text-align: right;padding-right: 0;">
                            <b>
                              {{ (Number(this.total_amt) + Number(this.delivery_type_price) + Number((this.runnerList.length-1)*this.delivery_type_price_addtional))  }}
                              THB</b>
                          </th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  <!-- now_tmp:{{ this.now }}
                  runner_count: {{ this.runner_count }} -->
                  <p>&nbsp;</p>
                
                    <!-- ข้อความเตือนสำหรับการ validation ทั้งหมด - รูปแบบทันสมัย -->
                    <div v-if="show_validation_errors && validation_errors.length > 0" class="alert alert-danger border-0 shadow-lg mb-4 modern-alert-order" role="alert">
                      <div class="d-flex align-items-center mb-3">
                        <div class="alert-icon-wrapper me-3">
                          <div class="alert-icon-circle">
                            <i class="fa fa-exclamation-triangle fa-lg text-white"></i>
                          </div>
                        </div>
                        <div>
                          <h5 class="alert-heading mb-1 fw-bold text-dark">
                            <i class="fa fa-list me-2 text-danger"></i>
                            {{this.currentLanguage ==='en'?'Missing Required Information':'ข้อมูลที่จำเป็นยังไม่ครบ'}}
                          </h5>
                          <p class="mb-0 text-muted small">{{this.currentLanguage ==='en'?'Please complete all required fields before creating your order':'กรุณากรอกข้อมูลให้ครบถ้วนก่อนสร้างคำสั่งซื้อ'}}</p>
                        </div>
                      </div>
                      <div class="error-checklist">
                        <div v-for="(error, index) in validation_errors" :key="index" class="error-item-modern d-flex align-items-start mb-2 p-2 rounded">
                          <div class="error-bullet me-3 mt-1">
                            <i class="fa fa-circle text-danger" style="font-size: 6px;"></i>
                          </div>
                          <span class="error-text-modern">{{ error }}</span>
                        </div>
                      </div>
                      <div class="alert-footer mt-3 pt-3 border-top border-light">
                        <small class="text-muted">
                          <i class="fa fa-info-circle me-1"></i>
                          {{this.currentLanguage ==='en'?'Complete these items to proceed with your registration':'กรอกรายการเหล่านี้ให้ครบเพื่อดำเนินการลงทะเบียน'}}
                        </small>
                      </div>
                    </div>
                
                    <!-- ข้อความเตือนสำหรับ checkbox - รูปแบบทันสมัย -->
                    <div v-if="show_terms_warning" class="alert alert-warning border-0 shadow-sm mb-3 modern-alert-terms" role="alert">
                      <div class="d-flex align-items-center justify-content-center">
                        <div class="terms-icon me-3">
                          <i class="fa fa-file-text fa-lg text-warning"></i>
                        </div>
                        <div class="text-center">
                          <h6 class="mb-1 fw-bold text-dark">
                            <i class="fa fa-hand-stop-o me-2 text-warning"></i>
                            {{this.currentLanguage ==='en'?'Terms Acceptance Required':'จำเป็นต้องยอมรับเงื่อนไข'}}
                          </h6>
                          <p class="mb-0">{{this.currentLanguage ==='en'?'Please accept the terms and conditions before creating an order.':'กรุณาเลือกเงื่อนไขข้อตกลงก่อนกดสร้างออเดอร์'}}</p>
                        </div>
                      </div>
                    </div>
                    
                    <div class="d-flex justify-content-center">
                      <button  
                        :disabled="this.is_submit_cart==='Y'" 
                        @click="checkTermsBeforeSubmit" 
                        type="button" 
                        :class="['btn', 'btn-lg', 'col-11', this.is_submit_cart === 'Y' ? 'btn-modern-processing' : 'btn-primary']"
                        style="border-radius: 0; position: relative; overflow: hidden; transition: all 0.3s ease;">
                        
                        <!-- Loading state with progress bar -->
                        <div v-if="this.is_submit_cart === 'Y'" class="progress-container">
                          <div class="progress-bar-animated"></div>
                          <div class="progress-glow"></div>
                        </div>
                        
                        <!-- Button text -->
                        <span class="button-text" :style="this.is_submit_cart === 'Y' ? 'color: #fff; position: relative; z-index: 3; font-weight: 600;' : ''">
                          <i v-if="this.is_submit_cart === 'Y'" class="fa fa-cog fa-spin me-2"></i>
                          {{this.is_submit_cart === 'Y' ? (this.currentLanguage ==='en'?'Processing...':'กำลังดำเนินการ...') : (this.currentLanguage ==='en'?'Create order':'สร้างออเดอร์')}}
                        </span>
                      </button>
                      <!-- &nbsp;
                      <button :disabled="this.is_submit_cart==='Y' ? '' : disabled" style="cursor: pointer" type="reset" @click.prevent="clear"
                        class="btn btn-secondary btn-lg">{{this.currentLanguage ==='en'?'Cancel':'ยกเลิก'}} </button> -->
                    </div>
                  
                </div>
              </div>
            </div>
            

            <div class="col-sm-12" v-if="this.runnerList.length > 0 && this.event_register.payment_method === 'FREE'">
              <div class="card">
                <div class="card-header">
                  
                    <!-- ข้อความเตือนสำหรับการ validation ทั้งหมด - รูปแบบทันสมัย -->
                    <div v-if="show_validation_errors && validation_errors.length > 0" class="alert alert-danger border-0 shadow-lg mb-4 modern-alert-order" role="alert">
                      <div class="d-flex align-items-center mb-3">
                        <div class="alert-icon-wrapper me-3">
                          <div class="alert-icon-circle">
                            <i class="fa fa-exclamation-triangle fa-lg text-white"></i>
                          </div>
                        </div>
                        <div>
                          <h5 class="alert-heading mb-1 fw-bold text-dark">
                            <i class="fa fa-list me-2 text-danger"></i>
                            {{this.currentLanguage ==='en'?'Missing Required Information':'ข้อมูลที่จำเป็นยังไม่ครบ'}}
                          </h5>
                          <p class="mb-0 text-muted small">{{this.currentLanguage ==='en'?'Please complete all required fields before creating your order':'กรุณากรอกข้อมูลให้ครบถ้วนก่อนสร้างคำสั่งซื้อ'}}</p>
                        </div>
                      </div>
                      <div class="error-checklist">
                        <div v-for="(error, index) in validation_errors" :key="index" class="error-item-modern d-flex align-items-start mb-2 p-2 rounded">
                          <div class="error-bullet me-3 mt-1">
                            <i class="fa fa-circle text-danger" style="font-size: 6px;"></i>
                          </div>
                          <span class="error-text-modern">{{ error }}</span>
                        </div>
                      </div>
                      <div class="alert-footer mt-3 pt-3 border-top border-light">
                        <small class="text-muted">
                          <i class="fa fa-info-circle me-1"></i>
                          {{this.currentLanguage ==='en'?'Complete these items to proceed with your registration':'กรอกรายการเหล่านี้ให้ครบเพื่อดำเนินการลงทะเบียน'}}
                        </small>
                      </div>
                    </div>
                
                    <!-- ข้อความเตือนสำหรับ checkbox - รูปแบบทันสมัย -->
                    <div v-if="show_terms_warning" class="alert alert-warning border-0 shadow-sm mb-3 modern-alert-terms" role="alert">
                      <div class="d-flex align-items-center justify-content-center">
                        <div class="terms-icon me-3">
                          <i class="fa fa-file-text fa-lg text-warning"></i>
                        </div>
                        <div class="text-center">
                          <h6 class="mb-1 fw-bold text-dark">
                            <i class="fa fa-hand-stop-o me-2 text-warning"></i>
                            {{this.currentLanguage ==='en'?'Terms Acceptance Required':'จำเป็นต้องยอมรับเงื่อนไข'}}
                          </h6>
                          <p class="mb-0">{{this.currentLanguage ==='en'?'Please accept the terms and conditions before creating an order.':'กรุณาเลือกเงื่อนไขข้อตกลงก่อนกดสร้างออเดอร์'}}</p>
                        </div>
                      </div>
                    </div>
                    <p>&nbsp;</p>
                    <div class="d-flex justify-content-center">
                      <button  
                        :disabled="this.is_submit_cart==='Y'" 
                        @click="checkTermsBeforeSubmit" 
                        type="button" 
                        :class="['btn', 'btn-lg', 'col-11', this.is_submit_cart === 'Y' ? 'btn-modern-processing' : 'btn-primary']"
                        style="border-radius: 0; position: relative; overflow: hidden; transition: all 0.3s ease;">
                        
                        <!-- Loading state with progress bar -->
                        <div v-if="this.is_submit_cart === 'Y'" class="progress-container">
                          <div class="progress-bar-animated"></div>
                          <div class="progress-glow"></div>
                        </div>
                        
                        <!-- Button text -->
                        <span class="button-text" :style="this.is_submit_cart === 'Y' ? 'color: #fff; position: relative; z-index: 3; font-weight: 600;' : ''">
                          <i v-if="this.is_submit_cart === 'Y'" class="fa fa-cog fa-spin me-2"></i>
                          {{this.is_submit_cart === 'Y' ? (this.currentLanguage ==='en'?'Processing...':'กำลังดำเนินการ...') : (this.currentLanguage ==='en'?'Register':'ลงทะเบียน')}}
                        </span>
                      </button>
                      <!-- &nbsp;
                      <button :disabled="this.is_submit_cart==='Y' ? '' : disabled" style="cursor: pointer" type="reset" @click.prevent="clear"
                        class="btn btn-secondary btn-lg">{{this.currentLanguage ==='en'?'Cancel':'ยกเลิก'}} </button> -->
                    </div>
        
                </div>
              </div>
            </div>


          </form>
      </div>

      </div>
      <div v-if="this.event_register.is_open_register === 'N'" >
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="d-flex justify-content-center">
             <p> {{this.currentLanguage ==='en'?'Registration will be open soon. Please stay tuned for further updates through our official channels.':'จะเปิดให้ลงทะเบียนในเร็วๆ นี้ โปรดติดตามข่าวสารเพิ่มเติมจากช่องทางอย่างเป็นทางการของเรา'}}</p>
            </div>
          </div>
          
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import router from "../../router";
import axios from "axios";
import { computed, reactive, ref } from "vue";
import { useHead } from "@vueuse/head";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import '@sweetalert2/theme-bootstrap-4/bootstrap-4.scss';
//import { useRunnerStore } from "../../store/modules/runner";
//const now_tmp = computed(() => Date.now())

export default {
  setup() {
    const siteData = reactive({
      title: `ระบบรับสมัครงานวิ่ง ราคาถูก มีฟังชั่นให้บริการครบๆ จบได้ในที่เดียว | RUNRACE.IN.TH`,
      description: `ระบบรับสมัครงานวิ่ง ราคาถูก มีฟังชั่นให้บริการครบๆ จบได้ในที่เดียว ติดต่อเปิดงานง่าย ใช้เวลาเพียง 1 วัน.. | RUNRACE.IN.TH`,
      keywords: `ระบบรับสมัครงานวิ่ง,RUNRACE.IN.TH`,
      image: `-`,
    });

    useHead({
      // Can be static or computed this.event_register.title
      title: computed(() => siteData.title),
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        {
          name: `keywords`,
          content: computed(() => siteData.keywords),
        },
        {
          property: `og:image`,
          content: computed(() => siteData.image),
        },{
          property: `og:title`,
          content: computed(() => siteData.title),
        },
        {
          property: `og:description`,
          content: computed(() => siteData.description),
        },
      ],
    });

    return { siteData};

    //const runner_store = useRunnerStore();
    //return { runner_store };
  },

  data() {
    return {
      isFoundImage: "true",
      event_register: {},
      eventPackage: {},
      provide: "0",
      runnerList: [],
      is_add_runner: "N",
      register_type: "MYSEFT",
      fname: "",
      lname: "",
      fname_en: "",
      lname_en: "",
      sex: null,
      current_province: null,
      dob: null,
      dobd: null,
      dobm: null,
      doby: null,
      nationality: null,
      id_card: null,
      email: "",
      mobile_no: "",
      health_problem: "",
      runner_team: "",
      blood_group: null,
      emergency_name: null,
      emergency_relation: null,
      emergency_mobile_no: null,
      run_type: 0,
      run_model:  0,
      t_shirt: 0,
      t_shirt_more: null,
      t_shirt_more_list: [],
      t_shirt_more_id: null,
      t_shirt_more_name: null,
      t_shirt_more_additional_price: 0,
      delivery_type: 0,
      delivery_type_id: 0,
      delivery_type_name: "",
      delivery_type_price: 0,
      delivery_type_price_addtional: 0,
      delivery_type_is_require_address: null,
      delivery_add_name: null,
      delivery_add_mobile_no: null,
      delivery_add_postcode: null,
      delivery_add_province_obj: [],
      delivery_add_province: null,
      delivery_add_district_obj: [],
      delivery_add_district: null,
      delivery_add_sub_district_obj: [],
      delivery_add_sub_district: null,
      delivery_add_no: null,
      total_amt: 0,
      paid_amt: 0,
      runner_action: "ADD",
      payment_method: null,
      payment_fee_pp: 0.03,
      payment_fee_cc: 0.05,
      is_main_register: null,
      is_submit_cart: "N",

      additional1: 0,
      additional2: 0,
      additional3: 0,
      additional4: 0,
      item: [],
      currentLanguage: 'th',
      can_create_order_participate_full: 'LOADING',

      team_member_obj: [],
      teamMembers: [],
      teamBirthDays: Array.from({ length: 31 }, (_, index) => String(index + 1).padStart(2, '0')),
      teamBirthMonths: [
        { value: '01', th: 'มกราคม', en: 'January' }, { value: '02', th: 'กุมภาพันธ์', en: 'February' },
        { value: '03', th: 'มีนาคม', en: 'March' }, { value: '04', th: 'เมษายน', en: 'April' },
        { value: '05', th: 'พฤษภาคม', en: 'May' }, { value: '06', th: 'มิถุนายน', en: 'June' },
        { value: '07', th: 'กรกฎาคม', en: 'July' }, { value: '08', th: 'สิงหาคม', en: 'August' },
        { value: '09', th: 'กันยายน', en: 'September' }, { value: '10', th: 'ตุลาคม', en: 'October' },
        { value: '11', th: 'พฤศจิกายน', en: 'November' }, { value: '12', th: 'ธันวาคม', en: 'December' }
      ],
      teamBirthYears: Array.from({ length: 91 }, (_, index) => String(1934 + index)),
      t2_fname: null,
      t2_lname: null,
      t2_sex: null,
      t2_dobd: null,
      t2_dobm: null,
      t2_doby: null,
      t2_id_card: null,
      t2_mobile_no: null,
      t2_blood_group: null,
      t2_t_shirt: null,

      t3_fname: null,
      t3_lname: null,
      t3_sex: null,
      t3_dobd: null,
      t3_dobm: null,
      t3_doby: null,
      t3_id_card: null,
      t3_mobile_no: null,
      t3_blood_group: null,
      t3_t_shirt: null,

      coupon_code: "",
      is_apply_coupon: "N",
      is_found_coupon: "",
      coupon_obj: {},
      is_have_coupon: "N",
      
      // ตัวแปรสำหรับ checkbox และข้อความเตือน
      terms_accepted: false,
      show_terms_warning: false,
      
      // ตัวแปรสำหรับการ validation ทั้งหมด
      validation_errors: [],
      show_validation_errors: false

    };
  },
  async created() {
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
    //await this.getEventDetail(this.$route.params.event_key);
    // if(this.$route.params.event_key ==='sichon16'){
    //   this.id_card = "-"
    // }
  },
  
  async mounted() {
    let _data = await this.getEventDetail(this.$route.params.event_key);
    this.ensureAvailableRunTypeSelection();
    await this.load_t_shirt_more();
    if (this.event_register.is_run_model === 'Y' && this.run_type) {
      await this.load_run_model();
    }
    if(_data.payment_method === 'FREE' || this.$route.params.event_key ==='btl-ultra100k'){
      localStorage.removeItem("_runner_list")
    }
    if (localStorage.getItem('_runner_list') !== null) {
      this.runnerList = JSON.parse(localStorage.getItem('_runner_list'))
      // console.log("####"+this.runnerList.length)
       if(this.runnerList.length >= 1){
        //console.log("####xxx:"+this.runnerList[0].event_key)
        if(this.$route.params.event_key === this.runnerList[0].event_key){
         //console.log("####event exiting")
         
        }else{
         //console.log("####event new--> remove")
         localStorage.removeItem("_runner_list")
         this.runnerList = [];
         //localStorage.setItem('_runner_list_'+this.$route.params.event_key, JSON.stringify(this.runnerList))
        }
       }
    }

    this.can_create_order_participate_full = await this.fn_check_participate_limit()

    this.cal_cart_runner();
    this.define_main_register();
    //this.siteData.image = _data.coverurl ;
    //this.siteData.title = _data.title +' '+this.siteData.title ;
    //this.siteData.description = _data.title +' วันที่ '+_data.event_date_text+' ณ.'+_data.province+' '+this.siteData.description ;
  },
  methods: {
    getSelectedRunType() {
      return Array.isArray(this.event_register.run_type)
        ? this.event_register.run_type.find((item) => String(item.id) === String(this.run_type))
        : null;
    },
    isTeamRegistration() {
      const eventType = this.getSelectedRunType();
      return Boolean(eventType && eventType.is_team === 'Y' && Number(eventType.team_member) > 1);
    },
    isMoreTShirt() {
      const eventType = this.getSelectedRunType();
      return Boolean(eventType && eventType.is_more_t_shirt === 'Y');
    },
    async load_t_shirt_more() {
      // โหลด list ขนาดเสื้อตัวที่สอง เฉพาะเมื่อกิจกรรมมีประเภทการแข่งขันที่เปิดใช้เสื้อตัวที่สอง
      const hasMoreTShirt = Array.isArray(this.event_register.run_type)
        && this.event_register.run_type.some((item) => item.is_more_t_shirt === 'Y');
      if (!hasMoreTShirt || this.t_shirt_more_list.length > 0) {
        return;
      }
      try {
        const res = await axios.get("/v1/events/t-shirt-more/" + this.$route.params.event_key);
        if (res.data.status === 'success') {
          this.t_shirt_more_list = res.data.t_shirt_more;
        }
      } catch (error) {
        console.error('load_t_shirt_more error:', error);
      }
    },
    createEmptyTeamMember() {
      return {
        fname: '', lname: '', sex: null, dobd: null, dobm: null, doby: null,
        id_card: '', mobile_no: '', blood_group: null, t_shirt_id: null
      };
    },
    handleRunTypeChange() {
      if (this.event_register.is_run_model === 'Y') {
        this.load_run_model();
      }
      if (this.isMoreTShirt()) {
        this.load_t_shirt_more();
      } else {
        this.t_shirt_more = null;
      }
      this.syncTeamMembers();
    },
    syncTeamMembers() {
      const eventType = this.getSelectedRunType();
      const extraMemberCount = eventType && eventType.is_team === 'Y'
        ? Math.max(Number(eventType.team_member) - 1, 0)
        : 0;
      this.teamMembers = Array.from(
        { length: extraMemberCount },
        (_, index) => this.teamMembers[index] || this.createEmptyTeamMember()
      );
    },
    buildTeamMembers() {
      return this.teamMembers.map((member) => {
        const shirt = this.event_register.t_shirt.find((item) => item.id === member.t_shirt_id);
        return {
          fname: member.fname,
          lname: member.lname,
          sex: member.sex,
          dob: `${member.doby}-${member.dobm}-${member.dobd}`,
          id_card: member.id_card,
          mobile_no: member.mobile_no,
          blood_group: member.blood_group,
          t_shirt_id: member.t_shirt_id,
          t_shirt_name: shirt ? shirt.name : ''
        };
      });
    },
    getTeamMemberDetails(teamMemberObj) {
      if (!Array.isArray(teamMemberObj)) {
        return [];
      }
      return teamMemberObj.map((member) => {
        const legacyPrefix = member.t3_fname === undefined ? 't2' : 't3';
        return {
          fname: member.fname || member[`${legacyPrefix}_fname`] || '',
          lname: member.lname || member[`${legacyPrefix}_lname`] || '',
          sex: member.sex || member[`${legacyPrefix}_sex`] || '',
          dob: member.dob || member[`${legacyPrefix}_dob`] || '',
          id_card: member.id_card || member[`${legacyPrefix}_id_card`] || '',
          mobile_no: member.mobile_no || member[`${legacyPrefix}_mobile_no`] || '',
          blood_group: member.blood_group || member[`${legacyPrefix}_blood_group`] || '',
          t_shirt_name: member.t_shirt_name || member[`${legacyPrefix}_t_shirt_name`] || ''
        };
      });
    },
    setTeamMembersFromRunner(runner) {
      if (!this.isTeamRegistration()) {
        this.teamMembers = [];
        return;
      }
      this.teamMembers = (runner.team_member_obj || []).map((member) => {
        const legacyPrefix = member.t3_fname === undefined ? 't2' : 't3';
        const dob = member.dob || member[`${legacyPrefix}_dob`] || '';
        return {
          fname: member.fname || member[`${legacyPrefix}_fname`] || '',
          lname: member.lname || member[`${legacyPrefix}_lname`] || '',
          sex: member.sex || member[`${legacyPrefix}_sex`] || null,
          dobd: dob.substring(8, 10) || null,
          dobm: dob.substring(5, 7) || null,
          doby: dob.substring(0, 4) || null,
          id_card: member.id_card || member[`${legacyPrefix}_id_card`] || '',
          mobile_no: member.mobile_no || member[`${legacyPrefix}_mobile_no`] || '',
          blood_group: member.blood_group || member[`${legacyPrefix}_blood_group`] || null,
          t_shirt_id: member.t_shirt_id || member[`${legacyPrefix}_t_shirt_id`] || null
        };
      });
      this.syncTeamMembers();
    },
    validateTeamMembers() {
      if (!this.isTeamRegistration()) {
        return true;
      }
      return this.teamMembers.every((member) =>
        member.fname && member.fname.trim().length >= 3 &&
        member.lname && member.lname.trim().length >= 3 &&
        member.sex && member.dobd && member.dobm && member.doby &&
        member.id_card && member.id_card.trim().length >= 5 &&
        member.mobile_no && member.mobile_no.trim().length >= 10 &&
        member.blood_group && member.t_shirt_id
      );
    },
    isRunTypeAvailable(eventType) {
      const registeredCount = Number((eventType && eventType.registered_count) || 0);
      const slotsTarget = Number((eventType && eventType.slots_target) || 0);

      if (slotsTarget <= 0) {
        return true;
      }

      return registeredCount < slotsTarget;
    },
    getRunTypeOptionLabel(eventType) {
      const description = (eventType && eventType.description) ? eventType.description : "";
      const baseLabel = `${eventType.name} ราคา: ${eventType.price} THB ${description}`.trim();
      if (this.isRunTypeAvailable(eventType)) {
        return baseLabel;
      }

      return this.currentLanguage === 'en'
        ? `${baseLabel} (FULL)`
        : `${baseLabel} (เต็มแล้ว)`;
    },
    ensureAvailableRunTypeSelection() {
      if (!Array.isArray(this.event_register.run_type)) {
        return;
      }

      const selectedRunType = this.event_register.run_type.find((item) => String(item.id) === String(this.run_type));
      if (selectedRunType && this.isRunTypeAvailable(selectedRunType)) {
        return;
      }

      //const firstAvailable = this.event_register.run_type.find((item) => this.isRunTypeAvailable(item));
      //this.run_type = firstAvailable ? firstAvailable.id : 0;
    },
    removeForbiddenQuotes(value) {
      return typeof value === 'string' ? value.replace(/[\"']/g, '') : value;
    },
    sanitizeField(fieldName) {
      if (typeof this[fieldName] === 'string') {
        this[fieldName] = this.removeForbiddenQuotes(this[fieldName]);
      }
    },
    sanitizeAllStringFields() {
      const fields = [
        'fname', 'lname', 'fname_en', 'lname_en', 'current_province', 'nationality', 'id_card', 'email',
        'mobile_no', 'health_problem', 'runner_team', 'emergency_name',
        'emergency_relation', 'emergency_mobile_no', 'delivery_add_name',
        'delivery_add_mobile_no', 'delivery_add_no', 'coupon_code', 'custom_field1',
        't2_fname', 't2_lname', 't2_id_card', 't2_mobile_no',
        't3_fname', 't3_lname', 't3_id_card', 't3_mobile_no'
      ];
      for (const field of fields) {
        this.sanitizeField(field);
      }
    },
    sanitizeRunnerList() {
      this.runnerList = this.runnerList.map((runner) => {
        const sanitizedRunner = { ...runner };
        for (const key in sanitizedRunner) {
          if (Object.prototype.hasOwnProperty.call(sanitizedRunner, key) && typeof sanitizedRunner[key] === 'string') {
            sanitizedRunner[key] = this.removeForbiddenQuotes(sanitizedRunner[key]);
          }
        }
        if (Array.isArray(sanitizedRunner.team_member_obj)) {
          sanitizedRunner.team_member_obj = sanitizedRunner.team_member_obj.map((member) => {
            const sanitizedMember = { ...member };
            for (const key in sanitizedMember) {
              if (Object.prototype.hasOwnProperty.call(sanitizedMember, key) && typeof sanitizedMember[key] === 'string') {
                sanitizedMember[key] = this.removeForbiddenQuotes(sanitizedMember[key]);
              }
            }
            return sanitizedMember;
          });
        }
        return sanitizedRunner;
      });
    },
    blockForbiddenCharacters(event) {
      const target = event.target;
      if (!target) {
        return;
      }
      const tag = target.tagName;
      const isTextArea = tag === 'TEXTAREA';
      const isTextInput = tag === 'INPUT' && ['text', 'search', 'email', 'tel', 'url', 'password', ''].includes((target.type || '').toLowerCase());
      if (!isTextArea && !isTextInput) {
        return;
      }
      if (typeof event.data === 'string' && /[\"']/.test(event.data)) {
        event.preventDefault();
      }
    },
    blockForbiddenPaste(event) {
      const target = event.target;
      if (!target) {
        return;
      }
      const tag = target.tagName;
      const isTextArea = tag === 'TEXTAREA';
      const isTextInput = tag === 'INPUT' && ['text', 'search', 'email', 'tel', 'url', 'password', ''].includes((target.type || '').toLowerCase());
      if (!isTextArea && !isTextInput) {
        return;
      }
      const pasteText = event.clipboardData ? event.clipboardData.getData('text') : '';
      if (!/[\"']/.test(pasteText)) {
        return;
      }
      event.preventDefault();
      const sanitized = this.removeForbiddenQuotes(pasteText);
      const start = target.selectionStart ?? target.value.length;
      const end = target.selectionEnd ?? start;
      target.setRangeText(sanitized, start, end, 'end');
      target.dispatchEvent(new Event('input', { bubbles: true }));
    },
    // ฟังก์ชันสร้าง dummy ID card
    generateDummyIdCard() {
      const randomNum = Math.floor(Math.random() * 90000) + 10000000; // สร้างตัวเลข 5 หลัก (10000-99999)
      return `AUTO${randomNum}`;
    },
    
    // ฟังก์ชันจัดการเมื่อเปลี่ยนสถานะ hide_info
    handleHideInfoChange() {
      if (this.hide_info) {
        // ถ้าเลือก checkbox ให้สร้าง dummy ID
        this.id_card = this.generateDummyIdCard();
      } else {
        // ถ้าไม่เลือก checkbox ให้เคลียร์ ID card (เฉพาะถ้าเป็น dummy)
        //if (this.id_card && this.id_card.startsWith('dummy')) {
          this.id_card = '';
        //}
      }
    },
    
    // ฟังก์ชันตรวจสอบ validation ทั้งหมด
    validateAllFields() {
      this.validation_errors = [];
      
      // ตรวจสอบว่ามีผู้สมัครหรือยัง
      if (this.runnerList.length === 0) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please add at least one runner' 
          : 'กรุณาเพิ่มข้อมูลผู้สมัครอย่างน้อย 1 คน';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบการเลือกผู้สมัครหลัก (ถ้ามีผู้สมัครมากกว่า 0 คน)
      if (this.runnerList.length > 0 && (!this.is_main_register || this.is_main_register === null)) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select a main registrant' 
          : 'กรุณาเลือกผู้สมัครหลัก';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบ delivery type
      if (!this.delivery_type || this.delivery_type === 0) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select race kit pickup method' 
          : 'กรุณาเลือกวิธีการรับเสื้อและบิบ';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบที่อยู่ถ้าจำเป็น
      if (this.delivery_type_is_require_address === 'Y') {
        if (!this.delivery_add_name || this.delivery_add_name.trim() === '') {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please enter delivery name' 
            : 'กรุณากรอกชื่อผู้รับ';
          this.validation_errors.push(errorMsg);
        }
        
        if (!this.delivery_add_mobile_no || this.delivery_add_mobile_no.trim() === '') {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please enter delivery mobile number' 
            : 'กรุณากรอกเบอร์โทรผู้รับ';
          this.validation_errors.push(errorMsg);
        }
        
        if (!this.delivery_add_no || this.delivery_add_no.trim() === '') {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please enter delivery address' 
            : 'กรุณากรอกที่อยู่';
          this.validation_errors.push(errorMsg);
        }
        
        if (!this.delivery_add_postcode) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please select postcode' 
            : 'กรุณาเลือกรหัสไปรษณีย์';
          this.validation_errors.push(errorMsg);
        }
        
        if (!this.delivery_add_sub_district) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please select sub-district' 
            : 'กรุณาเลือกตำบล/แขวง';
          this.validation_errors.push(errorMsg);
        }
        
        if (!this.delivery_add_district) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please select district' 
            : 'กรุณาเลือกอำเภอ/เขต';
          this.validation_errors.push(errorMsg);
        }
        
        if (!this.delivery_add_province) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please select province' 
            : 'กรุณาเลือกจังหวัด';
          this.validation_errors.push(errorMsg);
        }
      }
      
      // ตรวจสอบ payment method
      if (this.event_register.payment_method !== 'DIRECT' && this.event_register.payment_method !== 'FREE') {
        if (!this.payment_method) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please select payment method' 
            : 'กรุณาเลือกวิธีการชำระเงิน';
          this.validation_errors.push(errorMsg);
        }
      }

      if (this.is_have_coupon === 'Y') {
        if (!this.coupon_code || this.coupon_code.trim() === '') {
          const errorMsg = this.currentLanguage === 'en'
            ? 'Please enter your discount code and click Apply coupon before creating the order'
            : 'กรุณาป้อนโค้ดส่วนลดที่ท่านมี และกด ใช้คูปอง/Apply coupon ก่อนสร้างออเดอร์';
          this.validation_errors.push(errorMsg);
        } else if (this.is_apply_coupon !== 'Y') {
          const errorMsg = this.currentLanguage === 'en'
            ? 'Please click Apply coupon and wait for the discount code to be accepted before creating the order'
            : 'กรุณากด ใช้คูปอง/Apply coupon และรอให้โค้ดส่วนลดได้รับการยืนยันก่อนสร้างออเดอร์';
          this.validation_errors.push(errorMsg);
        }
      }
      
      // ตรวจสอบ checkbox เงื่อนไข
      if (!this.terms_accepted) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please accept the terms and conditions of participation' 
          : 'กรุณายอมรับเงื่อนไขและข้อตกลง การเข้าร่วมกิจกรรม';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบ checkbox เงื่อนไขเพิ่มเติม (ถ้ามี)
      if (this.event_register.condition !== 'N') {
        const checkbox2 = document.getElementById('flexCheckChecked2');
        if (checkbox2 && !checkbox2.checked) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please accept the additional conditions' 
            : 'กรุณายอมรับเงื่อนไขเพิ่มเติม';
          this.validation_errors.push(errorMsg);
        }
      }
      
      return this.validation_errors.length === 0;
    },

    // ฟังก์ชันตรวจสอบ checkbox ก่อนสร้างออเดอร์
    checkTermsBeforeSubmit() {
      // ตรวจสอบ validation ทั้งหมดก่อน
      const isValid = this.validateAllFields();
      
      if (!isValid) {
        this.show_validation_errors = true;
        this.show_terms_warning = false;
        
        // เลื่อนหน้าจอไปที่ข้อความเตือน
        setTimeout(() => {
          const alertElement = document.querySelector('.alert-danger');
          if (alertElement) {
            alertElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
        return;
      }
      
      // ถ้าผ่าน validation ทั้งหมด ให้ซ่อนข้อความเตือนและสร้างออเดอร์
      this.show_validation_errors = false;
      this.show_terms_warning = false;
      this.create_order();
    },
    
    async get_coupon(){

    if(this.run_type === 138){
      alert("ท่านเลือกประเภทการสมัครแบบ TriO100KM ไม่สามารถใช้คูปองได้, กรุณาจ่ายในราคาปกติไปก่อน แล้วติดต่อแอดมินเพื่อขอคืนเงินส่วนต่าง ของส่วนลดคูปอง 10%");
      return false;
    
    }
      if(this.coupon_code === ''){
        alert("กรุณาป้อน ข้อมูลคูปอง!")
        document.getElementById("coupon_code").focus();
        return false;
      }
      let data = {
        event_key : this.$route.params.event_key,
        coupon_code: this.coupon_code
      }
      this.coupon_obj = (await axios.post("v1/order/coupon", data)).data;

      if(this.coupon_obj.is_found_coupon === 'Y'){
        this.is_apply_coupon = "Y"
        this.is_found_coupon = "Y"
        if(this.coupon_obj.discount_type === 'PERCENTAGE'){
          this.total_amt = Number(this.total_amt*(1-(Number(this.coupon_obj.discount)/100))).toFixed(2)
        }else{
          //fixprice
          this.total_amt = Number(this.coupon_obj.discount).toFixed(2)
        }
      }else{
        this.is_apply_coupon = "N"
        this.is_found_coupon = "N"
      }
    },
    async validateIdCardInput(event){
      const value = event.target.value
      const filtered = value.replace(/[^a-zA-Z0-9]/g, '')
      this.id_card = filtered
    },
    async validateMobileNoInput(event){
      const value = event.target.value
      const filtered = value.replace(/[^0-9]/g, '')
      this.mobile_no = filtered
    },
    async validateEmergencyMobileNoInput(event){
      const value = event.target.value
      const filtered = value.replace(/[^0-9]/g, '') 
      this.emergency_mobile_no = filtered
    },
    scrollToBottom() {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth' // ใช้ smooth scroll (ลื่น ๆ)
    })
    },
    async load_run_model() {
      const res = await axios.post("/v1/utils/run-model", {
        events_run_type_id: this.run_type,
        language: "TH"
      });
      if (res.data.status === "success") {
        this.event_register.run_model = res.data.body;
      }
    },
    async load_sub_district() {
      //console.log(this.delivery_add_postcode)
      const res = await axios.post("/v1/utils/sub-district", {
        id: this.delivery_add_postcode,
        language: "TH"
      });
      if (res.data.status === "success") {
        this.delivery_add_sub_district_obj = res.data.body;
        this.delivery_add_district_obj = []
        this.delivery_add_district = null
        this.delivery_add_province_obj = []
        this.delivery_add_province = []

      }
    },
    async load_district() {
      const res = await axios.post("/v1/utils/district", {
        id: this.delivery_add_sub_district.substring(0, this.delivery_add_sub_district.indexOf("_")),
        language: "TH"
      });
      if (res.data.status === "success") {
        this.delivery_add_district_obj = res.data.body;
      }
    },
    async load_province() {
      const res = await axios.post("/v1/utils/province", {
        id: this.delivery_add_district.substring(0, this.delivery_add_district.indexOf("_")),
        language: "TH"
      });
      if (res.data.status === "success") {
        this.delivery_add_province_obj = res.data.body;
        this.delivery_add_province = res.data.body[0].ref;
      }
    },
    async fn_check_participate_limit() {
      const isFreePayment = (this.event_register.payment_method || "").toUpperCase() === "FREE";
      const apiPath = isFreePayment
        ? "/v1/order/check-participate-limit-free"
        : "/v1/order/check-participate-limit";

      const res = await axios.post(apiPath, {
        event_key: this.$route.params.event_key,
        language: "TH"
      });
      if (res.data.status === "success") {
        return res.data.can_create_order;
      }else{
        return "N"
      }
    },
    async fn_check_is_exiting_runner(_data_obj) {
      const res = await axios.post("/v1/order/is_exiting_runner", _data_obj);
      if (res.data.status === "success") {
        return {
          exiting_runner: res.data.exiting_runner,
          message: res.data.message
        };
      }else{
        return {
          exiting_runner: "N",
          message: 'พบข้อผิดพลาด กรุณาติดต่อแอดมิน',
        };
      }
    },
    async create_order() {
    this.sanitizeAllStringFields();
    this.sanitizeRunnerList();

    //check limit 
    if(this.event_register.is_limit_participate === 'Y'){
      let _check_participate_limit = await this.fn_check_participate_limit();
      if(_check_participate_limit === 'N'){
        alert('ขณะนี้ผู้สมัครเต็มจำนวนแล้ว')
        return false;
      }
    }
    

      this.is_submit_cart = "Y";
      if (this.event_register.payment_method === 'DIRECT') {
        this.paid_amt = Number(Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt) + Number((this.runnerList.length-1)*this.delivery_type_price_addtional)).toFixed(2)
      } else {
      if(this.event_register.is_free_payment_fee === 'Y'){
        this.paid_amt = Number(Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt) + Number((this.runnerList.length-1)*this.delivery_type_price_addtional)).toFixed(2)
      }else{
        if(this.payment_method === 'CC_OPN'){
          this.paid_amt = Number((Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt)) + Number(Number(this.total_amt*this.payment_fee_cc) + Number(this.delivery_type_price*this.payment_fee_cc) + Number((this.runnerList.length*this.event_register.system_fee_amt)*this.payment_fee_pp)  )).toFixed(2)
        }else{
          this.paid_amt = Number((Number(this.total_amt) + Number(this.delivery_type_price) + Number(this.runnerList.length*this.event_register.system_fee_amt)) + Number(Number(this.total_amt*this.payment_fee_pp) + Number(this.delivery_type_price*this.payment_fee_pp) + Number((this.runnerList.length*this.event_register.system_fee_amt)*this.payment_fee_pp) )).toFixed(2)
        }
      }
       
        
      }

      let _id_card, _fname, _lname, _mobile_no, _email, _main_run_type_id

      for (let item_runner of this.runnerList) {
        if (item_runner.id_card === this.is_main_register) {
          _id_card = item_runner.id_card
          _fname = item_runner._fname
          _lname = item_runner._lname
          _mobile_no = item_runner.mobile_no
          _email = item_runner.email
          _main_run_type_id = item_runner.run_type_id
        }
      }

      //console.log("this.runnerList:"+JSON.stringify(this.runnerList))
      let data = {
        runner_list: this.runnerList,
        delivery_type_id: this.delivery_type,
        delivery_type_name: this.delivery_type_name,
        delivery_type_price: this.delivery_type_price,
        delivery_type_is_require_address: this.delivery_type_is_require_address === null ? "N" : this.delivery_type_is_require_address,
        delivery_add_no: this.delivery_add_no,
        delivery_add_name: this.delivery_add_name,
        delivery_add_mobile_no: this.delivery_add_mobile_no,
        delivery_add_postcode: this.delivery_add_postcode,
        delivery_add_province: this.delivery_add_province,
        delivery_add_district: this.delivery_add_district === null ? null : this.delivery_add_district.substring(this.delivery_add_district.indexOf("_") + 1, this.delivery_add_district.length),
        delivery_add_sub_district: this.delivery_add_sub_district === null ? null : this.delivery_add_sub_district.substring(this.delivery_add_sub_district.indexOf("_") + 1, this.delivery_add_sub_district.length),
        total_amt: (Number(this.total_amt) + Number(this.delivery_type_price) + Number((this.runnerList.length-1)*this.delivery_type_price_addtional) +  Number(this.runnerList.length*this.event_register.system_fee_amt)).toFixed(2),
        paid_amt: this.paid_amt,
        //payment_method: this.event_register.payment_method,
        is_main_register: this.is_main_register,
        id_card: _id_card,
        fname: _fname,
        lname: _lname,
        mobile_no: _mobile_no,
        email: _email,
        runner_count: this.runnerList.length,
        event_key: this.$route.params.event_key,
        payment_account_no: this.event_register.payment_account_no,
        payment_account_name: this.event_register.payment_account_name,
        payment_bank_name: this.event_register.payment_bank_name,
        payment_method: this.event_register.payment_method,
        payment_method: this.payment_method===null?this.event_register.payment_method:this.payment_method,
        team_member_obj: this.team_member_obj,
        txt_message_registed: this.event_register.txt_message_registed,
        is_coupon: this.event_register.is_coupon,
        coupon_code: this.coupon_code,
        custom_field1: this.custom_field1,
        main_run_type_id: _main_run_type_id,

      }

       //console.log("data" + JSON.stringify(data))
      // this.is_submit_cart = "N";
       //return false;
      if(data.payment_method === 'FREE'){
      }
      const res = await axios.post(data.payment_method === 'FREE'? "/v1/order/create-free" : "/v1/order/create", data);
      //console.log("res:" + JSON.stringify(res))
      if (res.data.status === "success") {
        let _title = 'สมัครลงทะเบียนกิจกรรม เลขที่ใบสมัคร ' + res.data.uuid + ' เรียบร้อย'
        if(this.currentLanguage === 'en'){
          _title = 'Register completed orderID: ' + res.data.uuid 
        }

        this.is_submit_cart = "N";
        this.runnerList = [];
        localStorage.removeItem("_runner_list")
        if(data.payment_method === 'FREE'){
            await Swal.fire({
              position: 'top-center',
              icon: 'success',
              title: _title,
              html: '<a href="/order/' + res.data.uuid + '"><button type="button" class="btn btn-success">ใบสมัคร/View</button></a>',
              showCloseButton: false,
              showConfirmButton: false,
            })
        }else{
          await Swal.fire({
            position: 'top-center',
            icon: 'success',
            title: _title,
            html: '<a href="/order/' + res.data.uuid + '"><button type="button" class="btn btn-success">ชำระเงิน/Payment</button></a>',
            showCloseButton: false,
            showConfirmButton: false,
          })
        }
        
      } else if(res.data.status === "full") {
        this.is_submit_cart = "N";

        await Swal.fire({
          position: 'top-center',
          icon: 'error',
          title: res.data.message,
          showConfirmButton: true,
          timer: 10000
        })

      } else {
        this.is_submit_cart = "N";
        await Swal.fire({
          position: 'top-center',
          icon: 'error',
          html: res.data.message+'!<br><br>พบข้อผิดพลาดระหว่างการทำรายการ กรุณาลองอีกครั้งหรือ แคบหน้าจอนี้ ติดต่อเพจ RUNRACE  ',
          showConfirmButton: true,
          timer: 10000
        })
      }

    },
    async delivery_type_change(_id) {
      for (let item_delivery_type of this.event_register.delivery_type) {
        if (item_delivery_type.id === _id) {
          this.delivery_type_id = item_delivery_type.id
          this.delivery_type_name = item_delivery_type.name
          this.delivery_type_price = item_delivery_type.price
          this.delivery_type_price_addtional = item_delivery_type.price_additional
          this.delivery_type_is_require_address = item_delivery_type.is_require_address
        }
      }
    },
    async cal_cart_runner() {
      this.total_amt = 0
      for (let item of this.runnerList) {
        this.total_amt += item.run_type_price + item.t_shirt_additional_price + Number(item.t_shirt_more_additional_price || 0)
      }


    },
    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events-perf/" + event_key);
      if (res.data.status === "success") {
        this.event_register = res.data;
        this.ensureAvailableRunTypeSelection();
        //this.event_register.run_model = []
        //this.eventPackage = res.data.package;
        this.siteData.title = this.event_register.title +" "+ this.siteData.title
        this.siteData.image = this.event_register.coverurl
        return res.data;
      } else {
        //alert("พบข้อผิดพลาด! ไม่พบ url ของกิจกรรม");
        router.push({ path: "/404" });
      }
    },
    async select_main_register(_id_card) {
      this.is_main_register = _id_card
      this.define_main_register();
    },
    async define_main_register() {

      if (this.runnerList.length === 1) {
        let runner_main = this.runnerList[0];
        this.is_main_register = runner_main.id_card

        this.delivery_add_name = runner_main.fname + " " + runner_main.lname
        this.delivery_add_mobile_no = runner_main.mobile_no
      } else if (this.runnerList.length > 1) {

        if(this.is_main_register === null || this.is_main_register === undefined){
          this.is_main_register = this.runnerList[0].id_card
        }
        for (let item_runner of this.runnerList) {
          if (this.is_main_register == item_runner.id_card) {
            this.delivery_add_name = item_runner.fname + " " + item_runner.lname
            this.delivery_add_mobile_no = item_runner.mobile_no
          }
        }

      }
    },
    // ฟังก์ชันตรวจสอบข้อมูลผู้สมัคร
    validateRunnerFields() {
      this.validation_errors = [];
      
      // ตรวจสอบประเภทการสมัคร
      if (!this.register_type) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select registration type' 
          : 'กรุณาเลือกประเภทการสมัคร';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบชื่อ
      if (!this.fname || this.fname.trim() === '' || this.fname.length < 3) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please enter first name (at least 3 characters)' 
          : 'กรุณากรอกชื่อ (อย่างน้อย 3 ตัวอักษร)';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบนามสกุล
      if (!this.lname || this.lname.trim() === '' || this.lname.length < 3) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please enter last name (at least 3 characters)' 
          : 'กรุณากรอกนามสกุล (อย่างน้อย 3 ตัวอักษร)';
        this.validation_errors.push(errorMsg);
      }
      if (this.event_register.is_store_name_en === 'Y' &&
          (!/^[A-Za-z0-9 ]+$/.test(this.fname_en) || !/[A-Za-z]/.test(this.fname_en) ||
           !/^[A-Za-z0-9 ]+$/.test(this.lname_en) || !/[A-Za-z]/.test(this.lname_en))) {
        this.validation_errors.push(this.currentLanguage === 'en'
          ? 'English first and last names must contain English letters, numbers, and spaces'
          : 'ชื่อและนามสกุลภาษาอังกฤษต้องมีเฉพาะตัวอักษรภาษาอังกฤษ ตัวเลข และเว้นวรรค');
      }
      
      // ตรวจสอบเพศ
      if (!this.sex) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select gender' 
          : 'กรุณาเลือกเพศ';
        this.validation_errors.push(errorMsg);
      }

      // ตรวจสอบจังหวัด
      if (!this.current_province) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select province' 
          : 'กรุณาเลือกจังหวัด';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบวันเกิด
      if (!this.dobd || this.dobd === '0') {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select birth date' 
          : 'กรุณาเลือกวันเกิด';
        this.validation_errors.push(errorMsg);
      }
      
      if (!this.dobm || this.dobm === '0') {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select birth month' 
          : 'กรุณาเลือกเดือนเกิด';
        this.validation_errors.push(errorMsg);
      }
      
      if (!this.doby || this.doby === '0') {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select birth year' 
          : 'กรุณาเลือกปีเกิด';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบสัญชาติ
      if (!this.nationality) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select nationality' 
          : 'กรุณาเลือกสัญชาติ';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบเลขบัตรประชาชน
      if (!this.id_card || this.id_card.trim() === '' || this.id_card.length < 5) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please enter ID card/Passport (at least 5 characters)' 
          : 'กรุณากรอกเลขบัตรประชาชน/พาสปอร์ต (อย่างน้อย 5 ตัวอักษร)';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบอีเมล (ถ้าจำเป็น)
      if (this.event_register.validate_email === 'Y') {
        if (!this.email || this.email.trim() === '') {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please enter email address' 
            : 'กรุณากรอกอีเมล';
          this.validation_errors.push(errorMsg);
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please enter valid email address' 
            : 'กรุณากรอกอีเมลให้ถูกต้อง';
          this.validation_errors.push(errorMsg);
        }
      }
      
      // ตรวจสอบเบอร์โทร
      if (!this.mobile_no || this.mobile_no.trim() === '' || this.mobile_no.length < 10) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please enter mobile number (10 digits)' 
          : 'กรุณากรอกเบอร์โทรศัพท์ (10 หลัก)';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบกรุ๊ปเลือด
    if (this.event_register.is_require_blood_group === 'Y') {
      if (!this.blood_group) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select blood group' 
          : 'กรุณาเลือกกรุ๊ปเลือด';
        this.validation_errors.push(errorMsg);
      }
    }
      
      // ตรวจสอบผู้ติดต่อฉุกเฉิน
    if (this.event_register.is_require_emergency_name === 'Y') {
      if (!this.emergency_name || this.emergency_name.trim() === '' || this.emergency_name.length < 3) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please enter emergency contact name (at least 3 characters)' 
          : 'กรุณากรอกชื่อผู้ติดต่อฉุกเฉิน (อย่างน้อย 3 ตัวอักษร)';
        this.validation_errors.push(errorMsg);
      }
    }
    if (this.event_register.is_require_emergency_relation === 'Y') {
      if (!this.emergency_relation || this.emergency_relation.trim() === '' || this.emergency_relation.length < 3) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please enter emergency contact relationship (at least 3 characters)' 
          : 'กรุณากรอกความสัมพันธ์กับผู้ติดต่อฉุกเฉิน (อย่างน้อย 3 ตัวอักษร)';
        this.validation_errors.push(errorMsg);
      }
    }
      
      // ตรวจสอบเบอร์โทรฉุกเฉิน (ถ้าจำเป็น)
      if (this.event_register.is_require_emergency_mobile_no === 'Y') {
        if (!this.emergency_mobile_no || this.emergency_mobile_no.trim() === '' || this.emergency_mobile_no.length < 10) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please enter emergency contact mobile number (at least 10 digits)' 
            : 'กรุณากรอกเบอร์โทรผู้ติดต่อฉุกเฉิน (อย่างน้อย 10 หลัก)';
          this.validation_errors.push(errorMsg);
        }
      }
      
      // ตรวจสอบประเภทการแข่งขัน
      if (!this.run_type || this.run_type === 0) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select race category' 
          : 'กรุณาเลือกประเภทการแข่งขัน';
        this.validation_errors.push(errorMsg);
      }
      
      // ตรวจสอบรุ่นการแข่งขัน (ถ้าจำเป็น)
      if (this.event_register.is_run_model === 'Y') {
        if (!this.run_model || this.run_model === 0) {
          const errorMsg = this.currentLanguage === 'en' 
            ? 'Please select race model' 
            : 'กรุณาเลือกรุ่นการแข่งขัน';
          this.validation_errors.push(errorMsg);
        }
      }
      
      // ตรวจสอบไซส์เสื้อ
      if (!this.t_shirt || this.t_shirt === 0) {
        const errorMsg = this.currentLanguage === 'en' 
          ? 'Please select T-shirt size' 
          : 'กรุณาเลือกไซส์เสื้อ';
        this.validation_errors.push(errorMsg);
      }

      // ตรวจสอบไซส์เสื้อตัวที่สอง (ถ้าประเภทการแข่งขันเปิดใช้)
      if (this.isMoreTShirt() && (!this.t_shirt_more || this.t_shirt_more === 0)) {
        const errorMsg = this.currentLanguage === 'en'
          ? 'Please select second T-shirt size'
          : 'กรุณาเลือกไซส์เสื้อตัวที่สอง';
        this.validation_errors.push(errorMsg);
      }

      if (!this.validateTeamMembers()) {
        const errorMsg = this.currentLanguage === 'en'
          ? 'Please complete all team member information'
          : 'กรุณากรอกข้อมูลสมาชิกในทีมให้ครบถ้วน';
        this.validation_errors.push(errorMsg);
      }
      
      return this.validation_errors.length === 0;
    },
    
    // ฟังก์ชันซ่อนข้อความเตือนเมื่อผู้ใช้เริ่มกรอกข้อมูล
    clearValidationErrors() {
      this.show_validation_errors = false;
      this.validation_errors = [];
    },
    
    async addRunner() {
      this.sanitizeAllStringFields();
      this.is_add_runner = "Y"
      try {
        // ตรวจสอบ validation ข้อมูลผู้สมัครก่อน
        const isValid = this.validateRunnerFields();
        
        if (!isValid) {
          // แสดง alert แทนการแสดงข้อความ validation ที่หน้าฟอร์ม
          let alertMsg = this.currentLanguage === 'en' 
            ? 'Please complete all required fields before adding runner'
            : 'กรุณากรอกข้อมูลให้ครบถ้วนก่อนเพิ่มผู้สมัคร';
          alert(alertMsg);
          return;
        }


        if (this.runner_action === 'EDIT') {
        let new_runner_list = []
        for (let item_runner of this.runnerList) {
          if (item_runner.id_card === this.id_card) {
            for (let item_run_type of this.event_register.run_type) {
              if (item_run_type.id === this.run_type) {
                this.run_type_id = item_run_type.id
                this.run_type_name = item_run_type.name
                this.run_type_description = item_run_type.description
                this.run_type_price = item_run_type.price
              }
            }

            for (let item_t_shirt of this.event_register.t_shirt) {
              if (item_t_shirt.id === this.t_shirt) {
                this.t_shirt_id = item_t_shirt.id
                this.t_shirt_name = item_t_shirt.name
                this.t_shirt_additional_price = item_t_shirt.additional_price
              }
            }

            this.t_shirt_more_id = null
            this.t_shirt_more_name = null
            this.t_shirt_more_additional_price = 0
            if (this.isMoreTShirt()) {
              for (let item_t_shirt_more of this.t_shirt_more_list) {
                if (item_t_shirt_more.id === this.t_shirt_more) {
                  this.t_shirt_more_id = item_t_shirt_more.id
                  this.t_shirt_more_name = item_t_shirt_more.name
                  this.t_shirt_more_additional_price = Number(item_t_shirt_more.additional_price || 0)
                }
              }
            }

            for (let item_run_model of this.event_register.run_model) {
              if (item_run_model.id === this.run_model) {
                this.run_model_id = item_run_model.id
                this.run_model_name = item_run_model.name
              }
            }

            if(this.event_register.is_run_model === 'N'){
              this.run_model_id = 0
              this.run_model_name = '-'
            }

            for (let item_additional1 of this.event_register.additional1_list) {
              if (item_additional1.id === this.additional1) {
                this.additional1_id = item_additional1.id
                this.additional1_name = item_additional1.name
              }
            }

            for (let item_additional2 of this.event_register.additional2_list) {
              if (item_additional2.id === this.additional2) {
                this.additional2_id = item_additional2.id
                this.additional2_name = item_additional2.name
              }
            }

            for (let item_additional3 of this.event_register.additional3_list) {
              if (item_additional3.id === this.additional3) {
                this.additional3_id = item_additional3.id
                this.additional3_name = item_additional3.name
              }
            }

            for (let item_additional4 of this.event_register.additional4_list) {
              if (item_additional4.id === this.additional4) {
                this.additional4_id = item_additional4.id
                this.additional4_name = item_additional4.name
              }
            }

            //edit team_member 138
            //console.log("edit++++++++++++++++++++ "+this.run_type)
            if(this.isTeamRegistration()){
              this.team_member_obj = this.buildTeamMembers();
            }
            if(false && this.run_type===138){
              for (let item_t_shirt of this.event_register.t_shirt) {
                if (item_t_shirt.id === this.t2_t_shirt) {
                  this.t2_t_shirt_name = item_t_shirt.name
                }
              }
              for (let item_t_shirt of this.event_register.t_shirt) {
                if (item_t_shirt.id === this.t3_t_shirt) {
                  this.t3_t_shirt_name = item_t_shirt.name
                }
              }

              this.team_member_obj = [
                  {
                    t2_fname: this.t2_fname,
                    t2_lname: this.t2_lname,
                    t2_sex: this.t2_sex,
                    t2_dob: this.t2_doby + "-" + this.t2_dobm + "-" + this.t2_dobd,
                    t2_id_card: this.t2_id_card,
                    t2_mobile_no: this.t2_mobile_no,
                    t2_blood_group: this.t2_blood_group,
                    t2_t_shirt_id: this.t2_t_shirt,
                    t2_t_shirt_name: this.t2_t_shirt_name
                  },
                  {
                    t3_fname: this.t3_fname,
                    t3_lname: this.t3_lname,
                    t3_sex: this.t3_sex,
                    t3_dob: this.t3_doby + "-" + this.t3_dobm + "-" + this.t3_dobd,
                    t3_id_card: this.t3_id_card,
                    t3_mobile_no: this.t3_mobile_no,
                    t3_blood_group: this.t3_blood_group,
                    t3_t_shirt_id: this.t3_t_shirt,
                    t3_t_shirt_name: this.t3_t_shirt_name
                  }
                ]
            }

            //console.log("edit####"+JSON.stringify(this.team_member_obj))
            const req = {
              event_key: this.$route.params.event_key,
              fname: this.fname,
              lname: this.lname,
              fname_en: this.event_register.is_store_name_en === 'Y' ? this.fname_en.trim() : null,
              lname_en: this.event_register.is_store_name_en === 'Y' ? this.lname_en.trim() : null,
              sex: this.sex,
              current_province: this.current_province,
              dob: this.doby + "-" + this.dobm + "-" + this.dobd,
              nationality: this.nationality,
              id_card: this.id_card,
              email: this.email,
              mobile_no: this.mobile_no,
              health_problem: this.health_problem,
              runner_team: this.runner_team,
              blood_group: this.blood_group,
              emergency_name: this.emergency_name,
              emergency_relation: this.emergency_relation,
              emergency_mobile_no: this.emergency_mobile_no,
              run_type_id: this.run_type_id,
              run_type_name: this.run_type_name,
              run_model_id: this.run_model_id,
              run_model_name: this.run_model_name,
              additional1_id: this.additional1_id,
              additional2_id: this.additional2_id,
              additional3_id: this.additional3_id,
              additional4_id: this.additional4_id,
              additional1_name: this.additional1_name,
              additional2_name: this.additional2_name,
              additional3_name: this.additional3_name,
              additional4_name: this.additional4_name,
              run_type_description: this.run_type_description,
              run_type_price: this.run_type_price,
              t_shirt_id: this.t_shirt_id,
              t_shirt_name: this.t_shirt_name,
              t_shirt_additional_price: this.t_shirt_additional_price,
              t_shirt_more_id: this.t_shirt_more_id,
              t_shirt_more_name: this.t_shirt_more_name,
              t_shirt_more_additional_price: this.t_shirt_more_additional_price,
              team_member_obj: this.isTeamRegistration() ? this.team_member_obj : null,
              custom_field1: this.custom_field1
            };

            //console.log("edit req:"+JSON.stringify(req))
            new_runner_list.push(req)
          } else {
            new_runner_list.push(item_runner)
          }
          localStorage.setItem("_runner_list", JSON.stringify(new_runner_list))
          this.runnerList = JSON.parse(localStorage.getItem('_runner_list'))
          this.cal_cart_runner();

          Swal.fire({
            position: 'top-center',
            icon: 'success',
            title: 'อัปเดทข้อมูล สำเร็จ',
            showConfirmButton: false,
            timer: 1500
          })
          //this.scrollToBottom();
        }
        } else {
          if (this.runnerList.filter(runner => runner.id_card == this.id_card).length == 1) {
        let txt = 'คุณได้เพิ่มนักวิ่งคนนี้ไปแล้ว<br> เลขบัตรประชาชน/พาสปอร์ต: ' + this.id_card
        if(this.currentLanguage === 'en'){
          txt = 'You have added this runner<br> ID card/Passport: ' + this.id_card
        }
          Swal.fire({
            position: 'top-center',
            icon: 'warning',
            title: txt,
            showConfirmButton: true,
            timer: 15000
          })
          } else {

         

          for (let item_run_type of this.event_register.run_type) {
            if (item_run_type.id === this.run_type) {
              this.run_type_id = item_run_type.id
              this.run_type_name = item_run_type.name
              this.run_type_description = item_run_type.description
              this.run_type_price = item_run_type.price
            }
          }

          for (let item_t_shirt of this.event_register.t_shirt) {
            if (item_t_shirt.id === this.t_shirt) {
              this.t_shirt_id = item_t_shirt.id
              this.t_shirt_name = item_t_shirt.name
              this.t_shirt_additional_price = item_t_shirt.additional_price
            }
          }

          this.t_shirt_more_id = null
          this.t_shirt_more_name = null
          this.t_shirt_more_additional_price = 0
          if (this.isMoreTShirt()) {
            for (let item_t_shirt_more of this.t_shirt_more_list) {
              if (item_t_shirt_more.id === this.t_shirt_more) {
                this.t_shirt_more_id = item_t_shirt_more.id
                this.t_shirt_more_name = item_t_shirt_more.name
                this.t_shirt_more_additional_price = Number(item_t_shirt_more.additional_price || 0)
              }
            }
          }

          for (let item_run_model of this.event_register.run_model) {
            if (item_run_model.id === this.run_model) {
              this.run_model_id = item_run_model.id
              this.run_model_name = item_run_model.name
            }
          }

          if(this.event_register.is_run_model === 'N'){
            this.run_model_id = 0
            this.run_model_name = '-'
          }

          //console.log('this.event_register.additional1_list:'+this.event_register.additional1_list.length)
          //console.log('this.event_register.additional2_list:'+this.event_register.additional2_list.length)
          //console.log('this.event_register.additional3_list:'+this.event_register.additional3_list.length)
          for (let item_additional1 of this.event_register.additional1_list) {
            if (item_additional1.id === this.additional1) {
              this.additional1_id = item_additional1.id
              this.additional1_name = item_additional1.name
            }
          }

          for (let item_additional2 of this.event_register.additional2_list) {
            if (item_additional2.id === this.additional2) {
              this.additional2_id = item_additional2.id
              this.additional2_name = item_additional2.name
            }
          }

          for (let item_additional3 of this.event_register.additional3_list) {
            if (item_additional3.id === this.additional3) {
              this.additional3_id = item_additional3.id
              this.additional3_name = item_additional3.name
            }
          }

          for (let item_additional4 of this.event_register.additional4_list) {
            if (item_additional4.id === this.additional4) {
              this.additional4_id = item_additional4.id
              this.additional4_name = item_additional4.name
            }
          }

          //edit team_member 138
          //console.log("add++++++++++++++++++++ "+this.run_type)
            if(this.isTeamRegistration()){
              this.team_member_obj = this.buildTeamMembers();
            }
            if(false && this.run_type===138){

              for (let item_t_shirt of this.event_register.t_shirt) {
                if (item_t_shirt.id === this.t2_t_shirt) {
                  this.t2_t_shirt_name = item_t_shirt.name
                }
              }
              for (let item_t_shirt of this.event_register.t_shirt) {
                if (item_t_shirt.id === this.t3_t_shirt) {
                  this.t3_t_shirt_name = item_t_shirt.name
                }
              }

              this.team_member_obj = [
                  {
                    t2_fname: this.t2_fname,
                    t2_lname: this.t2_lname,
                    t2_sex: this.t2_sex,
                    t2_dob: this.t2_doby + "-" + this.t2_dobm + "-" + this.t2_dobd,
                    t2_id_card: this.t2_id_card,
                    t2_mobile_no: this.t2_mobile_no,
                    t2_blood_group: this.t2_blood_group,
                    t2_t_shirt_id: this.t2_t_shirt,
                    t2_t_shirt_name: this.t2_t_shirt_name

                  },
                  {
                    t3_fname: this.t3_fname,
                    t3_lname: this.t3_lname,
                    t3_sex: this.t3_sex,
                    t3_dob: this.t3_doby + "-" + this.t3_dobm + "-" + this.t3_dobd,
                    t3_id_card: this.t3_id_card,
                    t3_mobile_no: this.t3_mobile_no,
                    t3_blood_group: this.t3_blood_group,
                    t3_t_shirt_id: this.t3_t_shirt,
                    t3_t_shirt_name: this.t3_t_shirt_name
                  }
                ]
            }

          //console.log("add####"+JSON.stringify(this.team_member_obj))

          const req = {
            event_key: this.$route.params.event_key,
            fname: this.fname,
            lname: this.lname,
            fname_en: this.event_register.is_store_name_en === 'Y' ? this.fname_en.trim() : null,
            lname_en: this.event_register.is_store_name_en === 'Y' ? this.lname_en.trim() : null,
            sex: this.sex,
            current_province: this.current_province,
            dob: this.doby + "-" + this.dobm + "-" + this.dobd,
            nationality: this.nationality,
            id_card: this.id_card,
            email: this.email,
            mobile_no: this.mobile_no,
            health_problem: this.health_problem,
            runner_team: this.runner_team,
            blood_group: this.blood_group,
            emergency_name: this.emergency_name,
            emergency_relation: this.emergency_relation,
            emergency_mobile_no: this.emergency_mobile_no,
            run_type_id: this.run_type_id,
            run_type_name: this.run_type_name,
            run_model_id: this.run_model_id,
            run_model_name: this.run_model_name,
            additional1_id: this.additional1_id,
            additional2_id: this.additional2_id,
            additional3_id: this.additional3_id,
            additional4_id: this.additional4_id,
            additional1_name: this.additional1_name,
            additional2_name: this.additional2_name,
            additional3_name: this.additional3_name,
            additional4_name: this.additional4_name,
            run_type_description: this.run_type_description,
            run_type_price: this.run_type_price,
            t_shirt_id: this.t_shirt_id,
            t_shirt_name: this.t_shirt_name,
            t_shirt_additional_price: this.t_shirt_additional_price,
            t_shirt_more_id: this.t_shirt_more_id,
            t_shirt_more_name: this.t_shirt_more_name,
            t_shirt_more_additional_price: this.t_shirt_more_additional_price,
            team_member_obj: this.isTeamRegistration() ? this.team_member_obj : null,
            custom_field1: this.custom_field1
          };

           //check ว่าเลขบัตรนี้ มีข้อมูลแล้วรหรือยัง id,event_key,paid,
          if(this.event_register.payment_method === 'FREE'){
            let req_data = {
            event_key: req.event_key,
            run_type_id: req.run_type_id,
            id_card: req.id_card,
            language: this.currentLanguage
          }
          
            let exiting_runner_obj = await this.fn_check_is_exiting_runner(req_data);
            if(exiting_runner_obj.exiting_runner === 'Y'){
              alert(exiting_runner_obj.message)
              return false;
            }
          }
          

          this.runnerList.push(req)
          localStorage.setItem("_runner_list", JSON.stringify(this.runnerList))
          this.cal_cart_runner();
          
          //this.scrollToBottom();
          this.fname = ""
          this.lname = ""
          this.fname_en = ""
          this.lname_en = ""
          this.id_card =""
          this.hide_info = false;
          this.teamMembers = [];
          this.syncTeamMembers();
          let htmlContent =  `
            <div style="text-align: center;">
              <b>ท่านเพิ่มผู้สมัครแล้ว <br>
                กรุณาเลื่อนลง ด้านล่างเพื่อกด สร้างออเดอร์<br> หรือเพิ่มผู้สมัครท่านอื่น เพิ่มเติม</b>
            </div>
        `
          if(this.event_register.max_runner_register_per_order === 1){
            htmlContent =  `
              <div style="text-align: center;">
                <b>ท่านเพิ่มผู้สมัครแล้ว <br>
                  กรุณาเลื่อนลง ด้านล่างเพื่อป้อนข้อมูลอื่นๆ และกด ลงทะเบียน</b><br><br>
                  สามารถสมัครได้ครั้งละ 1 ท่านเท่านั้น!
              </div>
          `

            Swal.fire({
              position: 'top-center',
              icon: 'info',
              html: htmlContent,
              confirmButtonText: this.currentLanguage === 'en' ? 'OK' : 'รับทราบ',
            }).then(() => {
              setTimeout(() => {
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
              }, 300);
            })
          } else {
            Swal.fire({
              position: 'top-center',
              icon: 'info',
              html: htmlContent,
              confirmButtonText: this.currentLanguage === 'en' ? 'OK' : 'รับทราบ',
            })
          }

          
          

          }
        }
        this.define_main_register();
      } finally {
        this.is_add_runner = "N";
      }
    },
    async runner_edit(_id_card) {
      this.runner_action = "EDIT"
      for (let item of this.runnerList) {
        if (item.id_card === _id_card) {
          this.fname = item.fname
          this.lname = item.lname
          this.fname_en = item.fname_en || ""
          this.lname_en = item.lname_en || ""
          this.sex = item.sex
          this.current_province = item.current_province
          this.dobd = item.dob.substring(8, 10)
          this.dobm = item.dob.substring(5, 7)
          this.doby = item.dob.substring(0, 4)
          this.nationality = item.nationality
          this.id_card = item.id_card

          this.email = item.email
          this.mobile_no = item.mobile_no
          this.health_problem = item.health_problem
          this.runner_team = item.runner_team
          this.blood_group = item.blood_group

          this.emergency_name = item.emergency_name
          this.emergency_relation = item.emergency_relation
          this.emergency_mobile_no = item.emergency_mobile_no
          this.run_type = item.run_type_id
          this.run_model = item.run_model_id
          this.t_shirt = item.t_shirt_id
          this.t_shirt_more = item.t_shirt_more_id || null
          this.additional1 = item.additional1_id
          this.additional2 = item.additional2_id
          this.additional3 = item.additional3_id
          this.additional4 = item.additional4_id
          this.custom_field1 = item.custom_field1


          if(false && this.run_type === 138){
            this.t2_fname = item.team_member_obj[0].t2_fname
            this.t2_lname = item.team_member_obj[0].t2_lname
            this.t2_sex = item.team_member_obj[0].t2_sex
            this.t2_dobd = item.team_member_obj[0].t2_dob.substring(8, 10)
            this.t2_dobm = item.team_member_obj[0].t2_dob.substring(5, 7)
            this.t2_doby = item.team_member_obj[0].t2_dob.substring(0, 4)
            this.t2_id_card = item.team_member_obj[0].t2_id_card
            this.t2_mobile_no = item.team_member_obj[0].t2_mobile_no
            this.t2_blood_group = item.team_member_obj[0].t2_blood_group
            this.t2_t_shirt = item.team_member_obj[0].t2_t_shirt_id

            this.t3_fname = item.team_member_obj[1].t3_fname
            this.t3_lname = item.team_member_obj[1].t3_lname
            this.t3_sex = item.team_member_obj[1].t3_sex
            this.t3_dobd = item.team_member_obj[1].t3_dob.substring(8, 10)
            this.t3_dobm = item.team_member_obj[1].t3_dob.substring(5, 7)
            this.t3_doby = item.team_member_obj[1].t3_dob.substring(0, 4)
            this.t3_id_card = item.team_member_obj[1].t3_id_card
            this.t3_mobile_no = item.team_member_obj[1].t3_mobile_no
            this.t3_blood_group = item.team_member_obj[1].t3_blood_group
            this.t3_t_shirt = item.team_member_obj[1].t3_t_shirt_id

          }
          this.setTeamMembersFromRunner(item);

        }
      }
      this.cal_cart_runner();
      document.getElementById("fname").focus();
    },
    async runner_delete(_id_card, _fname) {
      if (confirm('Delete ' + _fname +' ?')) {
        let runner_list_tmp = []
        for (let item of this.runnerList) {
          if (_id_card !== item.id_card) {
            runner_list_tmp.push(item)
          }
        }
        this.runnerList = runner_list_tmp;
        localStorage.setItem("_runner_list", JSON.stringify(this.runnerList))
      }
      this.cal_cart_runner();
    },
    async clear() {
      this.is_add_runner = 'N'
      this.register_type = "MYSEFT",
      this.runner_action = 'ADD'
      this.run_type = ""
      this.run_model = ""
      this.fname = ""
      this.lname = ""
      this.fname_en = ""
      this.lname_en = ""
      this.sex = ""
      this.current_province = null
      this.dob = ""
      this.nationality = null
      this.id_card = null
      this.email = null
      this.mobile_no = null
      this.health_problem = null
      this.runner_team = ""
      this.blood_group = null
      this.emergency_name = null
      this.emergency_relation = null
      this.emergency_mobile_no = null
      this.run_type = null
      this.run_model = null
      this.additional1 = null
      this.additional2 = null
      this.additional3 = null
      this.additional4 = null
      this.t_shirt = null
      this.t_shirt_more = null
      this.teamMembers = []
    }
  },
  watch: {
    hide_info(newValue) {
      this.handleHideInfoChange();
    }
  }
};
</script>
<style scoped>
.btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}
.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}

.stepper-item.completed .step-counter {
  background-color: #66b5ff;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  border-bottom: 2px solid #66b5ff;
  width: 100%;
  top: 20px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}

.stepper-item:last-child::after {
  content: none;
}

.blinking-text {
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0.3;
  }
}

/* Modern Alert Styles */
.modern-alert {
  background: linear-gradient(135deg, #fef7f7 0%, #fdf2f2 100%);
  border-left: 4px solid #dc3545;
  border-radius: 12px;
  padding: 1.5rem;
  animation: slideInDown 0.5s ease-out;
}

.modern-alert-order {
  background: linear-gradient(135deg, #fef7f7 0%, #fdf2f2 100%);
  border-left: 5px solid #dc3545;
  border-radius: 15px;
  padding: 2rem;
  position: relative;
  overflow: hidden;
  animation: slideInUp 0.6s ease-out;
}

.modern-alert-order::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #dc3545, #f8d7da, #dc3545);
  animation: shimmer 2s infinite;
}

.modern-alert-terms {
  background: linear-gradient(135deg, #fffbf0 0%, #fef9e7 100%);
  border-left: 4px solid #ffc107;
  border-radius: 12px;
  padding: 1.5rem;
  animation: pulse 2s infinite;
}

.alert-icon-wrapper {
  position: relative;
}

.alert-icon-circle {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
  animation: bounce 2s infinite;
}

.terms-icon {
  animation: wiggle 1s infinite;
}

.error-list {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid rgba(220, 53, 69, 0.1);
}

.error-checklist {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  padding: 1.2rem;
  border: 1px solid rgba(220, 53, 69, 0.1);
}

.error-item {
  transition: all 0.3s ease;
  padding: 0.5rem;
  border-radius: 6px;
}

.error-item:hover {
  background: rgba(220, 53, 69, 0.05);
  transform: translateX(5px);
}

.error-item-modern {
  background: rgba(248, 215, 218, 0.3);
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
}

.error-item-modern:hover {
  background: rgba(248, 215, 218, 0.6);
  border-left-color: #dc3545;
  transform: translateX(3px);
}

.error-text {
  font-weight: 500;
  color: #721c24;
}

.error-text-modern {
  font-weight: 500;
  color: #721c24;
  line-height: 1.4;
}

.error-bullet {
  margin-top: 0.2rem;
}

.alert-footer {
  background: rgba(255, 255, 255, 0.7);
  margin: -0.5rem -1rem -1rem -1rem;
  padding: 1rem 2rem;
  border-radius: 0 0 15px 15px;
}

/* Animations */
@keyframes slideInDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideInUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}

@keyframes bounce {
  0%, 20%, 53%, 80%, 100% {
    transform: translateY(0);
  }
  40%, 43% {
    transform: translateY(-8px);
  }
  70% {
    transform: translateY(-4px);
  }
  90% {
    transform: translateY(-2px);
  }
}

@keyframes wiggle {
  0%, 7% {
    transform: rotateZ(0);
  }
  15% {
    transform: rotateZ(-15deg);
  }
  20% {
    transform: rotateZ(10deg);
  }
  25% {
    transform: rotateZ(-10deg);
  }
  30% {
    transform: rotateZ(6deg);
  }
  35% {
    transform: rotateZ(-4deg);
  }
  40%, 100% {
    transform: rotateZ(0);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-alert, .modern-alert-order, .modern-alert-terms {
    padding: 1rem;
    margin: 1rem 0;
  }
  
  .alert-icon-circle {
    width: 35px;
    height: 35px;
  }
  
  .error-checklist, .error-list {
    padding: 0.8rem;
  }
}

/* Modern Button Styles */
.btn-modern-processing {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%) !important;
  border: none !important;
  color: #fff !important;
  position: relative;
  cursor: not-allowed !important;
  box-shadow: 0 4px 20px rgba(23, 162, 184, 0.4);
  transform: translateY(0);
  overflow: hidden;
}

.btn-modern-processing:hover {
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%) !important;
  transform: translateY(0) !important;
  box-shadow: 0 4px 20px rgba(23, 162, 184, 0.5);
}

.event-register-skeleton {
  width: 100%;
}

.event-cover {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  padding: 0;
  border: 0;
  border-radius: 0.6em;
  box-shadow: 0 0.25rem 1rem rgb(0 0 0 / 35%);
}

.skeleton-block {
  border-radius: 10px;
  background: linear-gradient(90deg, #e9eef5 20%, #f6f9fc 50%, #e9eef5 80%);
  background-size: 220px 100%;
  animation: shimmer 1.2s infinite linear;
}

.skeleton-cover {
  width: 100%;
  height: 260px;
  border-radius: 12px;
}

.skeleton-title {
  width: 62%;
  height: 30px;
}

.skeleton-line {
  width: 100%;
  height: 18px;
}

.skeleton-line-short {
  width: 46%;
}

@media (max-width: 768px) {
  .skeleton-cover {
    height: 180px;
  }

  .skeleton-title {
    width: 82%;
  }
}

.progress-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #17a2b8 0%, #138496 100%);
  overflow: hidden;
}

.progress-bar-animated {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 30%;
  background: linear-gradient(90deg, 
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.6) 50%,
    rgba(255, 255, 255, 0.1) 100%);
  animation: progressSlide 2s infinite ease-in-out;
  z-index: 1;
}

.progress-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, 
    transparent 0%,
    #fff 20%,
    #fff 80%,
    transparent 100%);
  animation: glowSlide 1.5s infinite ease-in-out;
  z-index: 2;
}

@keyframes progressSlide {
  0% {
    left: -30%;
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}

@keyframes glowSlide {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(400px);
    opacity: 0;
  }
}

.btn-modern-loading {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
  border: none !important;
  color: #fff !important;
  position: relative;
  cursor: not-allowed !important;
  box-shadow: 0 4px 20px rgba(40, 167, 69, 0.4);
  transform: translateY(0);
}

.btn-modern-loading:hover {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
  transform: translateY(0) !important;
  box-shadow: 0 4px 20px rgba(40, 167, 69, 0.5);
}

.loading-bar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
}

.loading-bar {
  position: absolute;
  top: 0;
  left: -100%;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, 
    transparent 0%, 
    rgba(255, 255, 255, 0.2) 25%, 
    rgba(255, 255, 255, 0.4) 50%, 
    rgba(255, 255, 255, 0.2) 75%, 
    transparent 100%);
  animation: movingBar 2s infinite ease-in-out;
}

.button-text {
  position: relative;
  z-index: 3;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes movingBar {
  0% {
    left: -100%;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}

/* Alternative: Color changing button */
.btn-modern-disabled {
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #feca57) !important;
  background-size: 300% 300% !important;
  border: none !important;
  color: #fff !important;
  position: relative;
  cursor: not-allowed !important;
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
  animation: gradientShift 3s ease infinite;
  font-weight: 600;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* Enhanced primary button */
.btn-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;
  transform: translateY(0);
  font-weight: 600;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}

.run-type-option-full {
  color: #dc3545;
  text-decoration: line-through;
}
</style>
